<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>

              <b-dropdown right no-caret variant="link" boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom title="Agregar Productos"
                          v-if="!isCostSuppliersProducts || isContents">
                <template #button-content>
                  <AppIcon name="add" label="Agregar Productos" />
                </template>
                <b-dropdown-item @click="add()" v-if="!isCostSuppliersProducts">
                  <AppIcon name="add" /> Agregar Producto
                </b-dropdown-item>
                <b-dropdown-item @click="openProductsWeb()" v-if="isContents">
                  <AppIcon name="diagram3" /> Configurar Productos para Sitio Web
                </b-dropdown-item>
                <b-dropdown-item @click="openImportCSV()" v-if="!isCostSuppliersProducts">
                  <AppIcon name="file-earmark-spreadsheet" /> Gestor de Importaciones
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.select.active" v-model="filters.active" placeholder="Estado" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Código o Nombre</label>
              <b-form-input type="text"
                            placeholder="Ingrese un código o nombre de producto"
                            v-model="filters.name"
                            size="sm"
                            v-on:keyup.enter.native="filterProducts">
              </b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Categorías</label>
              <v-select :options="arr.select.categorys" v-model="filters.categorys" placeholder="Categorías" :multiple="false" :select-on-tab="true" @input="filterLoadSubCategorys"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Subcategorías</label>
              <v-select :options="arr.select.subcategorys" v-model="filters.subcategorys" placeholder="Subcategorías" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;" v-if="hasLines">
              <label class="filter-label">Lineas</label>
              <v-select :options="arr.select.lines" v-model="filters.lines" placeholder="Lineas" :multiple="false" :select-on-tab="true" @input="filterLoadSubLines"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;" v-if="hasLines">
              <label class="filter-label">Sublineas</label>
              <v-select :options="arr.select.sublines" v-model="filters.sublines" placeholder="Sublineas" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;" v-if="hasCostsModule">
              <label class="filter-label">Proveedor</label>
              <v-select :options="arr.select.suppliers" v-model="filters.supplier" placeholder="Proveedor" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterProducts()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-row>
              <b-col sm="12">
                <b-form-checkbox v-model="filters.show_price_iva"
                                  switch
                                  size="sm"
                                  class="pull-left"
                                  @input="filterProducts()">
                  Mostrar precios con IVA incluido
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" class="mt-2">
                <b-table class="app-table crud-products-table"
                        ref="table"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :tbody-tr-class="rowClass"
                        @row-clicked="onRowClicked"
                        :busy="table.isBusy"
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <b>{{data.item.id}}</b>
                    </template>

                    <template v-slot:cell(name)="data">
                      <span :id="'popover-name-' + data.item.id" style="cursor:pointer;">                    
                        <div class="crud-products-title-table">
                          <span v-if="data.item.code" class="crud-products-code-table">
                            {{data.item.code}}
                            <span v-if="parameters.origenProducts && data.item.product_purchase" title="Proveedor de Compra">
                              | {{data.item.product_purchase.supplier_name}}
                            </span>
                            <br>
                          </span>
                          {{data.item.name}}
                        </div>
                      </span>

                      <b-popover custom-class="popover-name-products" :target="'popover-name-' + data.item.id" variant="info" triggers="hover">                            
                        <div v-html="showParseReferenceExternal(data.item)"></div>
                      </b-popover>                        
                    </template>
                    
                    <template v-slot:cell(prices)="data">     
                      <div @click="setPricesProducts(data.item)" class="crud-products-price-open">                                                         
                        <div v-if="data.item.prices && data.item.prices.length<3">
                          <div v-for="element in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                            <b>
                              <span v-if="element.list.reference">
                                {{element.list.reference.substring(0,5)}}
                              </span>
                              <span v-else>
                                {{element.list.name.substring(0,5)}}
                              </span>                              
                            </b> : 
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}} 
                            <span v-if="element.unit_measurement_result">{{element.unit_measurement_result.reference}}</span>
                            <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                              <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                            </span>
                          </div>
                        </div>
                        <div v-else>
                          <a href="javascript:void(0)" @click="setPricesProducts(data.item)">Ver Listas</a>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(prices_iva)="data">  
                      <div @click="setPricesProducts(data.item)" class="crud-products-price-open">                              
                        <div v-if="data.item.prices && data.item.prices.length<3">
                          <div v-for="element in data.item.prices" :key="element.id" :title="element.list.name + ' | IVA: ' + element.aliquot_iva +'%'" v-b-tooltip.hover>
                            <b>
                              <span v-if="element.list.reference">
                                {{element.list.reference.substring(0,5)}}
                              </span>
                              <span v-else>
                                {{element.list.name.substring(0,5)}}
                              </span>                              
                            </b> : 
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total_iva)}} 
                            <span v-if="element.unit_measurement_result">{{element.unit_measurement_result.reference}}</span>
                            <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                              <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                            </span>
                          </div>
                        </div>
                        <div v-else>
                          <a href="javascript:void(0)" @click="setPricesProducts(data.item)">Ver Listas</a>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(stock)="data">
                      <div v-if="canManageStockProduct(data.item)" @click="setStockProducts(data.item)" class="crud-products-stock-open" :title="'Stock Mínimo: ' + data.item.stock_minimum">
                        <div v-if="parseFloat(data.item.stock)>=parseFloat(data.item.stock_minimum)">
                          <span class="text-success">{{data.item.stock}}</span>                        
                        </div>
                        <div v-else>
                          <span class="text-danger">{{data.item.stock}}</span>
                        </div>
                      </div>
                      <AppIcon v-else-if="!getVariantProduct(data.item) && !productControlsStock(data.item)"
                               name="block"
                               class="crud-products-stock-disabled"
                               title="Sin control de stock"
                               v-b-tooltip.hover />
                    </template>

                    <template v-slot:cell(max_discount)="data">
                      <div class="text-center">
                        <span v-if="data.item.max_discount !== null && data.item.max_discount !== '' && parseFloat(data.item.max_discount) > 0">
                          {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.max_discount)/100)}}
                        </span>
                      </div>
                    </template>

                    <template v-slot:cell(variant)="data">
                      <div v-if="hasColorsWaist">
                        <b-button v-if="data.item.colors_waist.length"
                                  @click="openSub(data.item)"
                                  variant="secondary"
                                  size="sm"
                                  class="crud-products-table-button-variant">
                          {{data.item.colors_waist.length}} Items
                          <AppIcon name="chevron-right" />
                        </b-button>
                        <b-button v-else
                                  @click="openSub(data.item)"
                                  variant="outline-secondary"
                                  size="sm"
                                  v-b-tooltip.hover
                                  title="Cargar Variedades"
                                  class="crud-products-table-button-variant">
                          <AppIcon name="chevron-double-right" />
                        </b-button>
                      </div>
                      <div v-else>
                        <div v-if="hasColors">
                          <b-button v-if="data.item.colors.length"
                                    @click="openSub(data.item)"
                                    variant="secondary"
                                    size="sm"
                                    class="crud-products-table-button-variant">
                            {{data.item.colors.length}} Colores
                            <AppIcon name="chevron-right" />
                          </b-button>
                          <b-button v-else
                                    @click="openSub(data.item)"
                                    variant="outline-secondary"
                                    size="sm"
                                    v-b-tooltip.hover
                                    title="Cargar Colores"
                                    class="crud-products-table-button-variant">
                            <AppIcon name="chevron-double-right" />
                          </b-button>
                        </div>
                        <div v-else>
                          <div v-if="hasWaist">
                            <b-button v-if="data.item.waist.length"
                                      @click="openSub(data.item)"
                                      variant="secondary"
                                      size="sm"
                                      class="crud-products-table-button-variant">
                              {{data.item.waist.length}} Talles
                              <AppIcon name="chevron-right" />
                            </b-button>
                            <b-button v-else
                                      @click="openSub(data.item)"
                                      variant="outline-secondary"
                                      size="sm"
                                      v-b-tooltip.hover
                                      title="Cargar Talles"
                                      class="crud-products-table-button-variant">
                              <AppIcon name="chevron-double-right" />
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observations">
                        <span v-if="isMobileViewport">{{data.item.observations}}</span>
                        <span v-else v-b-tooltip.hover :title="data.item.observations">
                          <AppIcon name="chat-square-text" />
                        </span>
                      </div>
                    </template>

                    <template v-slot:cell(order)="data">
                      <b-badge variant="dark">{{data.item.order}}</b-badge>
                    </template>

                    <template v-slot:cell(show_print)="data">
                      <AppIcon v-if="data.item.show_print" class="h5 mb-0 text-success" name="eye" title="Imprime" />
                      <AppIcon v-else class="h5 mb-0 text-danger" name="eye-slash" title="NO Imprime" />
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-products-action-toggle-labeled' : 'app-table-action-toggle'"
                                  :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>

                        <b-dropdown-item @click="openSub(data.item)">
                          <AppIcon name="visibility" /> Visualizar
                        </b-dropdown-item>
                        <b-dropdown-item @click="openProductsWeb(data.item)" v-if="isContents">
                          <AppIcon name="edit" /> Configurar Web
                        </b-dropdown-item>
                        <b-dropdown-item @click="setPricesProducts(data.item)" v-if="modules.showPrices">
                          <AppIcon name="currency-dollar" /> Precios
                        </b-dropdown-item>
                        <b-dropdown-item @click="setStockProducts(data.item)" v-if="canManageStockProduct(data.item)">
                          <AppIcon name="box" /> Stock
                        </b-dropdown-item>

                        <b-dropdown-header>Acciones</b-dropdown-header>
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)" v-if="!isCostSuppliersProducts">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else
                            icon="reports"
                            title="No se encontraron productos"
                            description="Ajustá los filtros para ampliar la búsqueda, o agregá un producto nuevo con el botón Agregar." />

                <div class="app-table-footer">
                  <span class="list-view-toolbar__count" v-if="table.tablePaginate">
                    {{ table.tablePaginate.total }} registros
                  </span>
                  <b-link class="list-view-link" @click="openExport()">
                    <AppIcon name="download" class="mr-1" /> Exportar
                  </b-link>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del producto seleccionado -->
      <b-sidebar
          id="sidebar-product-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Producto"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.code">
                {{itemSelected.code}}
              </span>
              <div>{{itemSelected.name}}</div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrev"
                        v-b-tooltip.hover
                        title="Producto anterior"
                        @click="goPrev()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNext"
                        v-b-tooltip.hover
                        title="Producto siguiente"
                        @click="goNext()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': !itemSelected.active }">
              <span class="list-view-drawer__stat-label">Estado</span>
              <span class="list-view-drawer__stat-value">{{itemSelected.active ? 'Activo' : 'Inactivo'}}</span>
            </div>
            <div class="list-view-drawer__stat" v-if="canManageStockProduct(itemSelected)">
              <span class="list-view-drawer__stat-label">Stock</span>
              <span class="list-view-drawer__stat-value">{{itemSelected.stock}}</span>
            </div>
          </div>

          <div v-if="itemSelected.subcategory">
            <div class="list-view-drawer__section-title">
              <AppIcon name="diagram3" /> Categorías
            </div>
            <div>
              {{itemSelected.subcategory.category.name}} <AppIcon name="chevron-right" /> {{itemSelected.subcategory.name}}
            </div>
          </div>

          <div v-if="hasLines && itemSelected.subline">
            <div class="list-view-drawer__section-title">
              <AppIcon name="diagram3" /> Línea
            </div>
            <div>
              {{itemSelected.subline.line.name}} <AppIcon name="chevron-right" /> {{itemSelected.subline.name}}
            </div>
          </div>

          <!-- VARIANTES -->
          <div v-if="hasColorsWaist">
            <div class="list-view-drawer__section-title">
              <AppIcon name="palette" /> Color + Talle
            </div>
            <b-button @click="addSub(itemSelected)" type="button" variant="outline-dark" size="sm" class="float-right mb-2" v-b-tooltip.hover title="Agregar Variedad">
              <AppIcon name="add" /> Agregar
            </b-button>
            <b-table id="table-color-waist"
                      class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSubColorsWaist.items"
                      :fields="tableSubColorsWaist.fields"
                      v-if="tableSubColorsWaist.items.length">

              <template v-slot:cell(color)="data">
                {{data.item.color.name}}
              </template>

              <template v-slot:cell(waist)="data">
                {{data.item.waist.name}}
              </template>

              <template v-slot:cell(prices)="data">
                <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                  <div v-if="data.item.prices && data.item.prices.length<3">
                    <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                      <b>
                        <span v-if="element.list.reference">
                          {{element.list.reference.substring(0,5)}}
                        </span>
                        <span v-else>
                          {{element.list.name.substring(0,5)}}
                        </span>
                      </b> :
                      <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                        <span>
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}
                        </span>
                        <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                          <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                        </span>
                      </span>
                      <span v-else>
                        Heredado
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                  </div>
                </div>
              </template>

              <template v-slot:cell(prices_iva)="data">
                <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                  <div v-if="data.item.prices && data.item.prices.length<3">
                    <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                      <b>
                        <span v-if="element.list.reference">
                          {{element.list.reference.substring(0,5)}}
                        </span>
                        <span v-else>
                          {{element.list.name.substring(0,5)}}
                        </span>
                      </b> :
                      <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                        <span>
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}
                        </span>
                        <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                          <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                        </span>
                      </span>
                      <span v-else>
                        Heredado
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                  </div>
                </div>
              </template>

              <template v-slot:cell(stock)="data">
                <div v-if="canManageStockVariant()" @click="setStockProductsVariant(data.item)" class="crud-products-stock-open" :title="'Stock Mínimo: ' + data.item.stock_minimum">
                  <div v-if="parseFloat(data.item.stock)>=parseFloat(data.item.stock_minimum)">
                    <span class="text-success">{{data.item.stock}}</span>
                  </div>
                  <div v-else>
                    <span class="text-danger">{{data.item.stock}}</span>
                  </div>
                </div>
                <AppIcon v-else-if="!productControlsStock(itemSelected)"
                         name="block"
                         class="crud-products-stock-disabled"
                         title="Sin control de stock"
                         v-b-tooltip.hover />
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                  <template #button-content>
                    <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                  </template>
                  <b-dropdown-item @click="setPricesProductsVariant(data.item)" v-if="modules.showPrices">
                    <AppIcon name="currency-dollar" /> Precios
                  </b-dropdown-item>
                  <b-dropdown-item @click="setStockProductsVariant(data.item)" v-if="canManageStockVariant()">
                    <AppIcon name="box" /> Stock
                  </b-dropdown-item>
                  <b-dropdown-header>Acciones</b-dropdown-header>
                  <b-dropdown-item @click="editSub(data.item)">
                    <AppIcon name="edit" /> Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="removeSub(data.item)">
                    <AppIcon name="delete" class="text-danger" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <EmptyState v-else icon="palette" title="Sin variedades de color + talle" />
          </div>
          <div v-else>
            <div v-if="hasColors">
              <div class="list-view-drawer__section-title">
                <AppIcon name="palette" /> Color
              </div>
              <b-button @click="addSub(itemSelected)" type="button" variant="outline-dark" size="sm" class="float-right mb-2" v-b-tooltip.hover title="Agregar Variedad">
                <AppIcon name="add" /> Agregar
              </b-button>
              <b-table class="app-table app-table--compact"
                        responsive
                        stacked
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="tableSubColors.items"
                        :fields="tableSubColors.fields"
                        v-if="tableSubColors.items.length">

                <template v-slot:cell(color)="data">
                  {{data.item.color.name}}
                </template>

                <template v-slot:cell(prices)="data">
                  <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                    <div v-if="data.item.prices && data.item.prices.length<3">
                      <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                        <b>
                          <span v-if="element.list.reference">
                            {{element.list.reference.substring(0,5)}}
                          </span>
                          <span v-else>
                            {{element.list.name.substring(0,5)}}
                          </span>
                        </b> :
                        <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                          <span>
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}
                          </span>
                          <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                            <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                          </span>
                        </span>
                        <span v-else>
                          Heredado
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                    </div>
                  </div>
                </template>

                <template v-slot:cell(prices_iva)="data">
                  <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                    <div v-if="data.item.prices && data.item.prices.length<3">
                      <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                        <b>
                          <span v-if="element.list.reference">
                            {{element.list.reference.substring(0,5)}}
                          </span>
                          <span v-else>
                            {{element.list.name.substring(0,5)}}
                          </span>
                        </b> :
                        <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                          <span>
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}
                          </span>
                          <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                            <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                          </span>
                        </span>
                        <span v-else>
                          Heredado
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                    </div>
                  </div>
                </template>

                <template v-slot:cell(stock)="data">
                  <div v-if="canManageStockVariant()" @click="setStockProductsVariant(data.item)" class="crud-products-stock-open" :title="'Stock Mínimo: ' + data.item.stock_minimum">
                    <div v-if="parseFloat(data.item.stock)>=parseFloat(data.item.stock_minimum)">
                      <span class="text-success">{{data.item.stock}}</span>
                    </div>
                    <div v-else>
                      <span class="text-danger">{{data.item.stock}}</span>
                    </div>
                  </div>
                  <AppIcon v-else-if="!productControlsStock(itemSelected)"
                           name="block"
                           class="crud-products-stock-disabled"
                           title="Sin control de stock"
                           v-b-tooltip.hover />
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                    <template #button-content>
                      <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                    </template>
                    <b-dropdown-item @click="setPricesProductsVariant(data.item)" v-if="modules.showPrices">
                      <AppIcon name="currency-dollar" /> Precios
                    </b-dropdown-item>
                    <b-dropdown-item @click="setStockProductsVariant(data.item)" v-if="canManageStockVariant()">
                      <AppIcon name="box" /> Stock
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="editSub(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeSub(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

              </b-table>
              <EmptyState v-else icon="palette" title="Sin variedades de color" />
            </div>

            <div v-if="hasWaist">
              <div class="list-view-drawer__section-title">
                <AppIcon name="straighten" /> Talle
              </div>
              <b-button @click="addSub(itemSelected)" type="button" variant="outline-dark" size="sm" class="float-right mb-2" v-b-tooltip.hover title="Agregar Variedad">
                <AppIcon name="add" /> Agregar
              </b-button>
              <b-table class="app-table app-table--compact"
                        responsive
                        stacked
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="tableSubWaist.items"
                        :fields="tableSubWaist.fields"
                        v-if="tableSubWaist.items.length">

                <template v-slot:cell(waist)="data">
                  {{data.item.waist.name}}
                </template>

                <template v-slot:cell(prices)="data">
                  <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                    <div v-if="data.item.prices && data.item.prices.length<3">
                      <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                        <b>
                          <span v-if="element.list.reference">
                            {{element.list.reference.substring(0,5)}}
                          </span>
                          <span v-else>
                            {{element.list.name.substring(0,5)}}
                          </span>
                        </b> :
                        <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                          <span>
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}
                          </span>
                          <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                            <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                          </span>
                        </span>
                        <span v-else>
                          Heredado
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                    </div>
                  </div>
                </template>

                <template v-slot:cell(prices_iva)="data">
                  <div @click="setPricesProductsVariant(data.item)" class="crud-products-price-open">
                    <div v-if="data.item.prices && data.item.prices.length<3">
                      <div v-for="(element, index) in data.item.prices" :key="element.id" :title="element.list.name" v-b-tooltip.hover>
                        <b>
                          <span v-if="element.list.reference">
                            {{element.list.reference.substring(0,5)}}
                          </span>
                          <span v-else>
                            {{element.list.name.substring(0,5)}}
                          </span>
                        </b> :
                        <span v-if="(element.amount_total != itemSelected.prices[index].amount_total) || (element.desc != itemSelected.prices[index].desc)">
                          <span>
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total_iva)}}
                          </span>
                          <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                            <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                          </span>
                        </span>
                        <span v-else>
                          Heredado
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <a href="javascript:void(0)" @click="setPricesProductsVariant(data.item)">Ver Listas</a>
                    </div>
                  </div>
                </template>

                <template v-slot:cell(stock)="data">
                  <div v-if="canManageStockVariant()" @click="setStockProductsVariant(data.item)" class="crud-products-stock-open" :title="'Stock Mínimo: ' + data.item.stock_minimum">
                    <div v-if="parseFloat(data.item.stock)>=parseFloat(data.item.stock_minimum)">
                      <span class="text-success">{{data.item.stock}}</span>
                    </div>
                    <div v-else>
                      <span class="text-danger">{{data.item.stock}}</span>
                    </div>
                  </div>
                  <AppIcon v-else-if="!productControlsStock(itemSelected)"
                           name="block"
                           class="crud-products-stock-disabled"
                           title="Sin control de stock"
                           v-b-tooltip.hover />
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                    <template #button-content>
                      <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                    </template>
                    <b-dropdown-item @click="setPricesProductsVariant(data.item)" v-if="modules.showPrices">
                      <AppIcon name="currency-dollar" /> Precios
                    </b-dropdown-item>
                    <b-dropdown-item @click="setStockProductsVariant(data.item)" v-if="canManageStockVariant()">
                      <AppIcon name="box" /> Stock
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="editSub(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeSub(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

              </b-table>
              <EmptyState v-else icon="straighten" title="Sin variedades de talle" />
            </div>
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" v-if="isContents" @click="openProductsWeb(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Configurar Web
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="modules.showPrices" @click="setPricesProducts(itemSelected)">
              <AppIcon name="currency-dollar" class="mr-1" /> Precios
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="canManageStockProduct(itemSelected)" @click="setStockProducts(itemSelected)">
              <AppIcon name="box" class="mr-1" /> Stock
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && !isCostSuppliersProducts">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterProducts()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.filters" 
              :filters="crud.print.filters"
              :reference="crud.print.reference"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="xl"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-tabs card>
          <b-tab no-body>
            <template #title><AppIcon name="description" class="mr-1" /> General</template>
            <b-row>
              <b-col md="6" class="mb-4">
                <b-form-checkbox v-model="crud.form.active" 
                                  switch 
                                  size="sm" 
                                  class="pull-left"
                                  :disabled="isCostSuppliersProducts">
                  Activar (disponible en el sistema)
                </b-form-checkbox> 
              </b-col>                            
            </b-row>
            <b-row>                        
              <b-col md="3">
                <b-form-group label="Código">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.code"
                                required
                                placeholder="Ingresar un código"
                                :disabled="isCostSuppliersProducts">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
              <b-col md="9" v-if="parameters.enableProductShortName">
                <b-form-group label="Nombre Corto">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name_short"
                                placeholder="Ingresar un nombre corto"
                                :disabled="isCostSuppliersProducts">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col :md="parameters.enableProductShortName ? 12 : 9">
                <b-form-group :label="parameters.enableProductShortName ? 'Nombre Largo' : 'Nombre'">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre largo"
                                :disabled="isCostSuppliersProducts">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Código de Barra">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.barcode"
                                required
                                placeholder="Ingresar un código de barra"
                                :disabled="isCostSuppliersProducts">
                  </b-form-input>
                </b-form-group>
              </b-col>               
            </b-row>     

            <b-row>   
              <b-col md="6">
                <b-row>   
                  <b-col md="12">                
                    <FindObject type="productsCategory" 
                                @select-object="loadProductsCategory($event)" 
                                :valueID="crud.form.category_id"
                                tag="Categorías"
                                render="search"
                                :disabled="isCostSuppliersProducts"/>
                  </b-col>
                  <b-col md="12">                
                    <FindObject type="productsSubCategory" 
                                @select-object="loadProductsSubcategory($event)" 
                                :valueID="crud.form.subcategory_id"
                                tag="Sub Categorias"
                                :where="conditionals.subcategorys"
                                :key="crud.form.category_id"
                                render="search"
                                :disabled="isCostSuppliersProducts"/>
                  </b-col>
                </b-row>
              </b-col>      
              <b-col md="6" v-if="hasLines">
                <b-row>   
                  <b-col md="12">                                
                    <FindObject type="productsLine" 
                                @select-object="loadProductsLine($event)" 
                                :valueID="crud.form.line_id"
                                tag="Lineas"
                                render="search"
                                :disabled="isCostSuppliersProducts"/>
                  </b-col>
                  <b-col md="12">                                
                    <FindObject type="productsSubLine" 
                                @select-object="loadProductsSubline($event)" 
                                :valueID="crud.form.subline_id"
                                tag="Sub Linea"
                                :where="conditionals.sublines"
                                :key="crud.form.line_id"
                                render="search"
                                :disabled="isCostSuppliersProducts"/>                    
                  </b-col>
                </b-row>
              </b-col>          
            </b-row>
          </b-tab>

          <b-tab no-body v-if="parameters.haveUnitMeasurement">
            <template #title><AppIcon name="straighten" class="mr-1" /> Unidad Medida</template>
            <b-row>              
              <b-col lg="4" v-if="crud.form.haveCostProductPurchase">
                <b-form-group :label="'Unidad de Medida de Compra'">
                  <b-form-input type="text"
                                :readonly="true"
                                size="sm"                                
                                v-model="crud.form.unit_measurement_purchase.name"
                                placeholder="Ingrese un valor">
                  </b-form-input>            
                </b-form-group>                                
              </b-col>
              <b-col lg="4" v-else>
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Compra"
                            @select-object="loadUnitMeasurementPurchase($event)" 
                            :valueID="crud.form.unit_measurement_purchase_id"
                            render="search"/>                       
              </b-col>
                            
              <b-col lg="4">
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Venta"
                            @select-object="loadUnitMeasurementSale($event)" 
                            :valueID="crud.form.unit_measurement_sale_id"
                            render="search"/>                       
              </b-col>
              <b-col lg="3" v-if="crud.form.unit_measurement_purchase_id != crud.form.unit_measurement_sale_id">
                <b-form-group label="Variable" description="Variable de Conversión">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                v-model="crud.form.unit_measurement_sale_conversion"
                                placeholder="Ingrese un valor">
                  </b-form-input>            
                </b-form-group>
              </b-col>                
            </b-row>
            <b-row>
              <b-col lg="12">
                <b-form-checkbox v-model="crud.form.weighable" switch size="sm">
                  Producto pesable
                </b-form-checkbox>
                <small class="text-muted">Se pesa al preparar el pedido. Requiere conversión entre la unidad de venta y KG.</small>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body>
            <template #title><AppIcon name="article" class="mr-1" /> Observaciones</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <vue-editor v-model="crud.form.observations"></vue-editor>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body v-if="isProcessSellers">
            <template #title><AppIcon name="people" class="mr-1" /> Vendedores</template>
            <b-row>
              <b-col md="6">
                <b-form-group label="Descuento máximo" description="Porcentaje máximo permitido para vendedores. Si el valor es 0, no se tiene en cuenta para el control.">
                  <b-form-input type="number"
                                size="sm"
                                min="0"
                                max="100"
                                step="0.01"
                                v-model.number="crud.form.max_discount"
                                placeholder="Ingrese un porcentaje">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body v-if="showPriceEdit">
            <template #title><AppIcon name="currency-dollar" class="mr-1" /> Precios</template>
            <b-row>
              <b-col lg="8">
                <b-table class="mb-0 crud-products-table-prices app-table app-table--compact"
                        responsive
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :stacked="isMobileViewport ? 'md' : false"
                        :items="tablePrices.items"
                        :fields="tablePrices.fields"                            
                        v-if="tablePrices.items && tablePrices.items.length">   

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template> 
                  
                  <template v-slot:cell(list)="data">                
                    <div v-if="data.item.list">
                      {{data.item.list.name}}
                      <span v-if="data.item.list.public" class="crud-product-list-prices-public">
                        (Pública)
                      </span>
                    </div>
                  </template>                                                
                  
                  <template v-slot:cell(price_list)="data">       
                    <div v-if="data.item.unit_measurement_initial.reference != data.item.unit_measurement_result.reference">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_initial, data.item.desc, data.item))}}                
                      <span v-if="data.item.unit_measurement_initial">{{data.item.unit_measurement_initial.reference}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(price_public)="data">                
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_total, data.item.desc, data.item))}}                
                    <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
                  </template>

                  <template v-slot:cell(desc)="data">       
                    <div v-if="parseFloat(data.item.desc) > 0">
                      {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.desc)/100)}}
                    </div>
                  </template>

                  <template v-slot:cell(price_desc)="data">                
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
                    <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
                  </template>                  

                  <template v-slot:cell(price_iva)="data">                
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total_iva)}}                
                    <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
                  </template>

                </b-table>
                <EmptyState v-else icon="currency-dollar" title="No se encontraron precios para este producto" />
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body v-if="isProcessSales">
            <template #title><AppIcon name="receipt_long" class="mr-1" /> Fiscal</template>
            <b-row>
              <b-col lg="6">
                <FindObject render="search"
                            type="erpIvaConditions"
                            @select-object="loadIvaConditions($event)"
                            :valueID="crud.form.erp_iva_condition_id"
                            :disabled="isCostSuppliersProducts"/>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body v-if="isProcessAccounting">
            <template #title><AppIcon name="account_balance" class="mr-1" /> Cuenta Contable</template>
            <b-row>
              <b-col lg="6">
                <FindObject render="search"
                        type="accountingAccountsImputation"
                        @select-object="loadAccountingAccounts($event)"
                        :valueID="crud.form.accounting_accounts_id"
                        :where="conditionAccountingAccountsFilters"/>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab v-if="modules.showPrices">
            <template #title><AppIcon name="sort" class="mr-1" /> Ordenamiento</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Orden" description="Valor utilizado para ordenar en la impresión de listas de precios, catálogo web y flujo del sistema">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.order"
                                required
                                placeholder="Ingresar un orden numérico">
                  </b-form-input>
                </b-form-group>
              </b-col>         
              <b-col md="12" class="mb-4">
                <b-form-checkbox v-model="crud.form.show_print" 
                                  switch 
                                  size="sm" 
                                  class="pull-left">
                  Mostrar en impresión de lista de precios.
                </b-form-checkbox>                   
              </b-col>              
            </b-row>
          </b-tab>                      

          <b-tab v-if="parameters.showExternalApp">
            <template #title><AppIcon name="apps" class="mr-1" /> Apps de Terceros</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.show_external_app"
                                  switch
                                  size="sm"
                                  class="pull-left">
                  Muestra en Apps de Terceros.
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD SUB -->
      <b-modal v-model="modal.formSub.active"
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="palette" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formSub.title}}</h5>
        </div>

        <b-tabs card>

          <b-tab no-body>
            <template #title><AppIcon name="palette" class="mr-1" /> Variantes</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.formSub.active" 
                                  switch 
                                  size="sm" 
                                  class="mb-4 pull-left">
                  Activar
                </b-form-checkbox>            
              </b-col>                 
              <b-col md="12">
                <FindObject type="products" 
                            @select-object="loadVarietyProducts($event)" 
                            :valueID="crud.formSub.products_id"
                            tag="Producto"/>
              </b-col>
                        
              <b-col md="3">
                <b-form-group label="Código">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.formSub.code"
                                required
                                placeholder="Ingresar un código">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
              <b-col md="9">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.formSub.name"
                                required
                                placeholder="Ingresar un nombre">
                  </b-form-input>
                </b-form-group>
              </b-col> 
            
              <b-col md="12">
                <b-row> 
                  <b-col md="4">                                                                       
                    <b-form-group label="Variante">
                      <b-form-select v-model="crud.formSub.typeVariant" 
                                     :options="arr.select.typeVariant" 
                                     :disabled="true"></b-form-select>
                    </b-form-group>                
                  </b-col>
                  <b-col v-show="crud.formSub.typeVariant=='COLOR' || crud.formSub.typeVariant=='COLOR-WAIST'">                    
                      <FindObject type="productsColors" 
                                  @select-object="loadVarietyColors($event)" 
                                  :valueID="crud.formSub.colors_id"                                  
                                  tag="Color"/>
                  </b-col>
                  <b-col v-show="crud.formSub.typeVariant=='WAIST' || crud.formSub.typeVariant=='COLOR-WAIST'">
                      <FindObject type="productsWaist" 
                                  @select-object="loadVarietyWaist($event)" 
                                  :valueID="crud.formSub.waist_id"                                  
                                  tag="Talle"/>                         
                  </b-col>               
                </b-row>            
              </b-col> 
            </b-row>
          </b-tab>
          
          <b-tab no-body v-if="showPriceVariantEdit">
            <template #title><AppIcon name="currency-dollar" class="mr-1" /> Precios</template>
            <b-col md="12">
              <b-table class="mb-0 crud-products-table-prices app-table app-table--compact"
                      responsive
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :stacked="isMobileViewport ? 'md' : false"
                      :items="tablePricesVariant.items"
                      :fields="tablePricesVariant.fields"                            
                      v-if="tablePricesVariant.items.length">   

                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"                    
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template> 

                <template v-slot:cell(list)="data">                
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-product-list-prices-public">
                    (Pública)
                  </span>
                </template>                                                
                
                <template v-slot:cell(price)="data">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_total, data.item.desc, data.item))}}                
                </template>

                <template v-slot:cell(desc)="data">       
                  <div v-if="parseFloat(data.item.desc) > 0">
                    {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.desc)/100)}}
                  </div>
                </template>

                <template v-slot:cell(price_desc)="data">                
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
                  <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
                </template>

                <template v-slot:cell(price_iva)="data">                
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total_iva)}}                
                  <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
                </template>                
              </b-table>
              <EmptyState v-else icon="currency-dollar" title="No se encontraron precios para esta variedad de producto" />
            </b-col>
          </b-tab>

          <b-tab v-if="parameters.showExternalApp && crud.formSub.typeVariant=='COLOR'">
            <template #title><AppIcon name="apps" class="mr-1" /> Apps de Terceros</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.formSub.show_external_app"
                                  switch
                                  size="sm"
                                  class="pull-left">
                  Muestra en Apps de Terceros.
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formSub.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveSub()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD PRECIOS -->
      <b-modal  v-model="modal.formPrice.active"
                size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="currency-dollar" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formPrice.title}}</h5>
        </div>

        <b-row>         
          <b-col md="12">
            <div class="crud-products-title" v-if="itemSelected">
              <div class="crud-products-title">
                <span v-if="itemSelected.code" class="crud-products-code">
                  {{this.itemSelected.code}} 
                </span><br>
                {{this.itemSelected.name}}
              </div>
              <hr>
            </div>
          </b-col>
          <b-col md="4">
            <b-form-group label="Lista">
              <v-select :options="arr.select.listPrice" 
                        v-model="crud.formPrice.price_list_select" 
                        placeholder="Lista"
                        :disabled="crud.formPrice.id>0 || isCostSuppliersProducts">
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Descuento">
              <b-form-input type="number"
                            v-model="crud.formPrice.desc"
                            step="0.01"
                            max="100"
                            placeholder="Ingresar el Descuento"
                            :disabled="isCostSuppliersProducts">
              </b-form-input>
            </b-form-group>            
          </b-col>                
          <b-col md="4">
            <b-form-group label="Precio">
              <b-form-input type="number"
                            v-model="crud.formPrice.amount"
                            step="0.01"
                            placeholder="Ingresar el precio"
                            :disabled="isCostSuppliersProducts">
              </b-form-input>
            </b-form-group>            
          </b-col>        
          <b-col md="2">                
            <b-button variant="dark" 
                      @click="saveFormPrice()"
                      title="Guardar Precio"
                      class="crud-products-button-save-price pull-right"
                      :disabled="isCostSuppliersProducts">
              <AppIcon name="add" v-if="crud.formPrice.id==0" />
              <AppIcon name="save" v-else />
            </b-button>
            <b-button variant="outline-danger"
                      @click="cancelSaveFormPrice()"
                      title="Cancelar Edición"
                      class="crud-products-button-save-price pull-right mr-1"
                      :disabled="isCostSuppliersProducts"
                      v-if="crud.formPrice.id>0">
              <AppIcon name="x" />
            </b-button>
          </b-col>
          <b-col md="12">
            <b-table class="mb-0 crud-products-table-prices app-table app-table--compact"
                    responsive
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :stacked="isMobileViewport ? 'md' : false"
                    :items="tablePrices.items"
                    :fields="tablePrices.fields"                            
                    v-if="tablePrices.items && tablePrices.items.length">   

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 
              
              <template v-slot:cell(list)="data">                
                <div v-if="data.item.list">
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-product-list-prices-public">
                    (Pública)
                  </span>
                </div>
              </template>                                                

              <template v-slot:cell(price_list)="data">       
                <div v-if="data.item.unit_measurement_initial.reference != data.item.unit_measurement_result.reference">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_initial, data.item.desc, data.item))}}                
                  <span v-if="data.item.unit_measurement_initial">{{data.item.unit_measurement_initial.reference}}</span>
                </div>
              </template>

              <template v-slot:cell(price_public)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_total, data.item.desc, data.item))}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(desc)="data">       
                <div v-if="parseFloat(data.item.desc) > 0">
                  {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.desc)/100)}}
                </div>
              </template>

              <template v-slot:cell(price_desc)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(price_iva)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total_iva)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right
                            no-caret
                            size="sm"
                            variant="link"
                            boundary="window"
                            :toggle-class="isMobileViewport ? 'crud-products-action-toggle-labeled' : 'app-table-action-toggle'"
                            :class="{ 'pull-right': !isMobileViewport }"
                            :disabled="crud.formPrice.id>0"
                            v-if="!isCostSuppliersProducts">
                  <template #button-content>
                    <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                    <span v-if="isMobileViewport">Opciones</span>
                  </template>
                  <b-dropdown-item @click="editPricesProducts(data.item)">
                    <AppIcon name="edit" /> Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="removePricesProducts(data.item)">
                    <AppIcon name="delete" class="text-danger" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <EmptyState v-else icon="currency-dollar" title="No se encontraron precios para este producto" />
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formPrice.active=false">Salir</b-button>
        </div>
      </b-modal>

      <!-- CRUD PRECIOS VARIEDADES -->
      <b-modal  v-model="modal.formPriceVariant.active"
                size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="currency-dollar" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formPriceVariant.title}}</h5>
        </div>

        <b-row>         
          <b-col md="12" class="mb-2">
            <div class="crud-products-title" v-if="itemSelected && itemSelectedVariant">
              <b-row>
                <b-col md="6" class="crud-products-title">
                  <span v-if="itemSelected.code" class="crud-products-code">
                    {{this.itemSelected.code}} 
                  </span><br>
                  {{this.itemSelected.name}}
                </b-col>
                <b-col md="6" class="crud-products-title">              
                  <span v-if="itemSelectedVariant.code" class="crud-products-code">
                    {{this.itemSelectedVariant.code}} 
                  </span><br>
                  {{this.itemSelectedVariant.name}} <br>
                  
                  <div v-if="itemSelectedVariant.color">
                    <AppIcon name="circle-fill" />
                    {{this.itemSelectedVariant.color.name}}
                  </div>
                  <div v-if="itemSelectedVariant.waist">
                    <AppIcon name="circle-fill" />
                    {{this.itemSelectedVariant.waist.name}}
                  </div>

                </b-col>
              </b-row>
              <hr>
            </div>
          </b-col>

          <b-col md="12" v-if="crud.formPriceVariant.id>0">
            <b-row>
              <b-col md="4">
                <b-form-group label="Lista">
                  <v-select :options="arr.select.listPrice" 
                            v-model="crud.formPriceVariant.price_list_select" 
                            placeholder="Lista"
                            :disabled="true">
                  </v-select>
                </b-form-group>
              </b-col>    
              <b-col md="2">
                <b-form-group label="Descuento">
                  <b-form-input type="number"
                                v-model="crud.formPriceVariant.desc"
                                step="0.01"
                                max="100"
                                placeholder="Ingresar el Descuento">
                  </b-form-input>
                </b-form-group>            
              </b-col>                
              <b-col md="4">
                <b-form-group label="Precio">
                  <b-form-input type="number"
                                v-model="crud.formPriceVariant.amount"
                                step="0.01"
                                placeholder="Ingresar el precio">
                  </b-form-input>
                </b-form-group>            
              </b-col>
              <b-col md="2">                
                <b-button variant="dark" 
                          @click="saveFormPriceVariant()"
                          title="Guardar Precio"
                          class="crud-products-button-save-price pull-right">
                  <AppIcon name="save" />
                </b-button>
                <b-button variant="outline-danger"
                          @click="cancelSaveFormPriceVariant()"
                          title="Cancelar Edición"
                          class="crud-products-button-save-price pull-right mr-1">
                  <AppIcon name="x" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-table class="mb-0 crud-products-table-prices app-table app-table--compact"
                    responsive
                    :hover="true"
                    :small="true"
                    :fixed="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :items="tablePricesVariant.items"
                    :fields="tablePricesVariant.fields"
                    v-if="tablePricesVariant.items.length">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>              

              <template v-slot:cell(list)="data">                
                {{data.item.list.name}}
                <span v-if="data.item.list.public" class="crud-product-list-prices-public">
                  (Pública)
                </span>
              </template>                                                
              
              <template v-slot:cell(price)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_total, data.item.desc, data.item))}}                
              </template>

              <template v-slot:cell(desc)="data">       
                <div v-if="parseFloat(data.item.desc) > 0">
                  {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.desc)/100)}}
                </div>
              </template>

              <template v-slot:cell(price_desc)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(price_iva)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total_iva)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-button size="sm"
                          variant="link"
                          class="app-table-icon-btn"
                          :class="{ 'pull-right': !isMobileViewport }"
                          :disabled="crud.formPriceVariant.id>0"
                          v-b-tooltip.hover
                          title="Editar"
                          @click="editPricesProductsVariant(data.item)">
                  <AppIcon name="edit" label="Editar" :class="{ 'mr-1': isMobileViewport }" />
                  <span v-if="isMobileViewport">Editar</span>
                </b-button>
              </template>

            </b-table>
            <EmptyState v-else icon="currency-dollar" title="No se encontraron precios para esta variedad de producto" />
          </b-col>
        </b-row>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formPriceVariant.active=false">Salir</b-button>          
        </div>
      </b-modal>

      <!-- CRUD STOCK -->
      <b-modal  v-model="modal.formStock.active"
                size="md">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="box" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formStock.title}}</h5>
        </div>

        <b-row>       
          <b-col md="12">    
            <div class="crud-products-title" v-if="itemSelected">
              <div class="crud-products-title">
                <span v-if="itemSelected.code" class="crud-products-code">
                  {{this.itemSelected.code}} 
                  <br>
                </span>
                {{this.itemSelected.name}}
              </div>              
            </div>
          </b-col>

          <b-col md="12">            
            <hr>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-input-group size="sm" prepend="Stock Mínimo">
              <b-form-input type="number" min="0.00" v-model="crud.formStockMinimum.stock_minimum"></b-form-input>

              <b-input-group-append>
                <b-button variant="success" @click="saveFormStockMinimum()">
                  <AppIcon name="check" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <small class="form-text text-muted">El Stock Mínimo es utilizado para mostrar alertas por productos en el sistema.</small>
          </b-col>

          <b-col md="12" v-if="isProcessDeposit">
            <b-table class="mb-0 app-table app-table--compact"
                    responsive
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :stacked="isMobileViewport ? 'md' : false"
                    :items="tableStock.items"
                    :fields="tableStock.fields"
                    v-if="tableStock.items.length">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(deposit)="data">
                <DepositLocationLabel :location="data.item.location" />
              </template>

              <template v-slot:cell(quantity)="data">
                {{ parseFloat(data.item.quantity).toFixed(2) }}
                <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
              </template>
            </b-table>
            <EmptyState v-else icon="box" title="No se encontró stock" />
          </b-col>

          <b-col md="12" v-if="!isProcessDeposit && crud.formStock.unit_measurement">
              <b-form-group label="Cantidad Disponible" 
                            description="Ingrese la cantidad actual para este producto.">
                <b-input-group size="sm" :append="crud.formStock.unit_measurement.reference">
                  <b-form-input type="number"
                                v-model="crud.formStock.stock"
                                step="0.01"
                                placeholder="Ingresar stock">
                  </b-form-input>
                </b-input-group>
              </b-form-group>            
          </b-col> 
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formStock.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveFormStock()" v-if="!isProcessDeposit">Actualizar</b-button>          
        </div>

      </b-modal>  

      <!-- CRUD STOCK VARIEDADES -->
      <b-modal  v-model="modal.formStockVariant.active"
                size="md">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="box" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formStockVariant.title}}</h5>
        </div>

        <b-row>       
          <b-col md="12" class="mb-2">
            <div class="crud-products-title" v-if="itemSelected && itemSelectedVariant">
              <b-row>
                <b-col md="6" class="crud-products-title">
                  <span v-if="itemSelected.code" class="crud-products-code">
                    {{this.itemSelected.code}} 
                    <br>
                  </span>
                  {{this.itemSelected.name}}
                </b-col>
                <b-col md="6" class="crud-products-title">              
                  <span v-if="itemSelectedVariant.code" class="crud-products-code">
                    {{this.itemSelectedVariant.code}} 
                    <br>
                  </span>
                  {{this.itemSelectedVariant.name}} <br>
                  
                  <div v-if="itemSelectedVariant.color">
                    <AppIcon name="circle-fill" />
                    {{this.itemSelectedVariant.color.name}}
                  </div>
                  <div v-if="itemSelectedVariant.waist">
                    <AppIcon name="circle-fill" />
                    {{this.itemSelectedVariant.waist.name}}
                  </div>

                </b-col>
              </b-row>
            </div>
          </b-col>

          <b-col md="12">
            <hr>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-input-group size="sm" prepend="Stock Mínimo">
              <b-form-input type="number" min="0.00" v-model="crud.formStockMinimum.stock_minimum"></b-form-input>

              <b-input-group-append>
                <b-button variant="success" @click="saveFormStockMinimumVariant()">
                  <AppIcon name="check" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <small class="form-text text-muted">El Stock Mínimo es utilizado para mostrar alertas por productos en el sistema.</small>
          </b-col>

          <b-col md="12" v-if="isProcessDeposit">
            <b-table class="mb-0 app-table app-table--compact"
                    responsive
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :stacked="isMobileViewport ? 'md' : false"
                    :items="tableStock.items"
                    :fields="tableStock.fields"
                    v-if="tableStock.items.length">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template>

              <template v-slot:cell(deposit)="data">
                <DepositLocationLabel :location="data.item.location" />
              </template>

              <template v-slot:cell(quantity)="data">
                {{ parseFloat(data.item.quantity).toFixed(2) }}
                <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
              </template>
            </b-table>
            <EmptyState v-else icon="box" title="No se encontró stock" />
          </b-col>

          <b-col md="12" v-if="!isProcessDeposit && crud.formStock.unit_measurement">
              <b-form-group label="Cantidad Disponible"
                            description="Ingrese la cantidad actual para esta variedad">
                <b-input-group size="sm" :append="crud.formStock.unit_measurement.reference">
                  <b-form-input type="number"
                                v-model="crud.formStockVariant.stock"
                                step="0.01"
                                placeholder="Ingresar stock">
                  </b-form-input>
                </b-input-group>
              </b-form-group>            
          </b-col> 
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formStockVariant.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveFormStockVariant()" v-if="!isProcessDeposit">Actualizar</b-button>          
        </div>

      </b-modal>  

      <!-- CRUD IMPORTACIONES -->
      <b-modal  v-model="modal.formImport.active"
                size="lg"
                :key="modal.formImport._id"
                :id="modal.formImport._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="file-earmark-spreadsheet" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formImport.title}}</h5>
        </div>

        <b-tabs pills card :vertical="!isMobileViewport">
          <b-tab title="Nuevos Productos" @click="crud.formImport.type='import_store_products'" active >
            <b-card-text>
              <b-row>
                <b-col md="12" class="mb-2">
                  <b-alert show variant="info">
                      <h4 class="alert-heading">Importación de Productos</h4>

                      <div>
                        <AppIcon name="chevron-right" /> El sistema importará todos los registros cargados en el archivo.
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Esta importación solo permite agregar <b>productos</b>.
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Si el <b>código</b> ya existe en la base de datos, se omite dicho registro.
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Las <b>categoría, subcategoría, linea y sublinea</b>, sino existe las crea (busca coincidencia por nombre).
                      </div>
                      <div v-if="hasColors || hasColorsWaist">
                        <AppIcon name="chevron-right" /> El <b>color</b> asignado a la variedad, sino existe las crea (busca coincidencia por nombre).
                      </div>
                      <div v-if="hasWaist || hasColorsWaist">
                        <AppIcon name="chevron-right" /> El <b>talle</b> asignado a la variedad, sino existe las crea (busca coincidencia por nombre).
                      </div>

                      <hr>

                      <div class="mb-0" v-if="!hasAnyVariant">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-products.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasColors && !hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-products-colors.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasWaist && !hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-products-waist.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-products-colors-waist.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>                                                                  
                    </b-alert>                  
                </b-col>
                <b-col md="12" class="mb-2">                  
                  <b-form-group label="Archivo CSV [Productos]">                
                    <b-form-file v-model="crud.formImport.file"
                                  size="sm"
                                  :state="Boolean(crud.formImport.file)"
                                  placeholder="Elija un archivo o sueltelo aquí..."
                                  drop-placeholder="Suelta el archivo aquí...">
                    </b-form-file>                    
                  </b-form-group>         
                </b-col> 
              </b-row>              
            </b-card-text>
          </b-tab>
          <b-tab title="Actualización de Precios" @click="crud.formImport.type='import_update_products_prices'">
            <b-card-text>          
              <b-row>
                <b-col md="12" class="mb-2">
                  <b-alert show variant="info">
                      <h4 class="alert-heading">Actualización de Precios</h4>
                      <div>
                        <AppIcon name="chevron-right" /> El sistema importará todos los registros cargados en el archivo. <br>
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Esta importación solo permite actualizar precio de productos por lista de precios.
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Con el <b>código</b> de producto, se busca en la base de datos para identificar el producto. <br>
                      </div>
                      <div>
                        <AppIcon name="chevron-right" /> Buscará el precio en la <b>lista de precio</b> seleccionada y le asigna el precio cargado en el archivo. <br>
                      </div>

                      <hr>
  
                      <div class="mb-0" v-if="!hasAnyVariant">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-price-products.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasColors && !hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-price-products-colors.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasWaist && !hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-price-products-waist.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>
                      <div class="mb-0" v-if="hasColorsWaist">
                        Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/products/csv-format-price-products-colors-waist.csv')"><b>formato de ejemplo</b></a> para esta importación.
                      </div>                      
                    </b-alert>                  
                </b-col>                
                <b-col md="12" class="mb-2">  
                  <FindObject type="priceList" 
                              @select-object="loadListPriceImportCSV($event)" 
                              :valueID="crud.formImport.price_list_id"
                              render="search"/>
                </b-col>                   
                <b-col md="12" class="mb-2">  
                  <b-form-group label="Archivo CSV [Precio Productos]">                
                    <b-form-file v-model="crud.formImport.file"
                                  size="sm"
                                  :state="Boolean(crud.formImport.file)"
                                  placeholder="Elija un archivo o sueltelo aquí..."
                                  drop-placeholder="Suelta el archivo aquí...">
                    </b-form-file>                    
                  </b-form-group>   
                </b-col>
              </b-row>                
            </b-card-text>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formImport.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="importCSV()">Importar</b-button>          
        </div>
      </b-modal>  

      <!-- CRUD EXPORTACIONES -->
      <b-modal  v-model="modal.formExport.active"
                size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="download" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formExport.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Lista">
              <v-select :options="arr.select.listPrice"
                        v-model="modal.formExport.price_list"
                        placeholder="Lista">
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="modal.formExport.price_list">
            <b-overlay :show="modal.formExport.overlay" rounded="sm">
              <b-table-simple hover small caption-top responsive class="app-table app-table--compact">
                <b-thead>
                  <b-tr>
                    <b-th>Tipo de Exportación</b-th>
                    <b-th class="text-right">Acciones</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>Lista de precios completa. <i>[Aplica Filtros]</i></b-td>
                    <b-td class="text-right">
                      <b-button-group size="sm">
                        <b-button @click="downloadSource('filter-full-list-price')" class="mr-1">
                          <AppIcon name="download" />
                          CSV
                        </b-button>
                        <b-button @click="printPDF('filter-full-list-price')" class="mr-1">
                          <AppIcon name="print" />
                          PDF
                        </b-button>
                      </b-button-group>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Lista de precios completa. Oculta productos sin precio (precios en cero). <i>[Aplica Filtros]</i></b-td>
                    <b-td class="text-right">
                      <b-button-group size="sm">
                        <b-button @click="downloadSource('filter-full-list-price-hide-price-zero')" class="mr-1">
                          <AppIcon name="download" />
                          CSV
                        </b-button>
                        <b-button @click="printPDF('filter-full-list-price-hide-price-zero')" class="mr-1">
                          <AppIcon name="print" />
                          PDF
                        </b-button>
                      </b-button-group>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Productos modificados en los últimos 7 días. <i>[Aplica Filtros]</i></b-td>
                    <b-td class="text-right">
                      <b-button-group size="sm">
                        <b-button @click="downloadSource('filter-list-price-last-update')" class="mr-1">
                          <AppIcon name="download" />
                          CSV
                        </b-button>
                        <b-button @click="printPDF('filter-list-price-last-update')" class="mr-1">
                          <AppIcon name="print" />
                          PDF
                        </b-button>
                      </b-button-group>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-overlay>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formExport.active=false">Cancelar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'  
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'  
  import Param from '@/config/parameters'  
  import axios from 'axios'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import { VueEditor } from "vue2-editor";
  import Funciones from '@/handler/funciones'
  import moment from 'moment'
  import Printer from '@/components/inc/printer/printer'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  const defaultFilters = () => ({
    lines: null,
    sublines: null,
    categorys: null,
    subcategorys: null,
    supplier: null,
    name: '',
    active: {code:true, label: 'Activo'},
    listFullToCSV: false,
    price_list_id: 0,
    last_update_days: 0,
    show_price_iva: false,
    hide_price_zero: false,
    // Le pide al backend que eager-cargue el proveedor de compra por defecto
    // (ver ProductsController::getFilterProducts) en vez de recalcularlo con
    // una query por producto/variante/precio — opt-in, no afecta a otras
    // pantallas que comparten ese mismo método.
    eagerProductPurchase: true,
  })

  export default {
    components: {
      FindObject,
      VueEditor,
      Printer,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudProducts',
          elements: {}
        }, 
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),
          haveColors: Helper.hasParametersAccess(Param.P8),
          haveWaist: Helper.hasParametersAccess(Param.P9),
          haveMeasurement: Helper.hasParametersAccess(Param.P10),
          haveColorsWaist: Helper.hasParametersAccess(Param.P17),          
          hideStock: Helper.hasParametersAccess(Param.P19),        
          haveUnitMeasurement: Helper.hasParametersAccess(Param.P31), 
          showExternalApp: Helper.hasParametersAccess(Param.P55), 
          origenProducts: Helper.hasParametersAccess(Param.P62), 
          enableProductShortName: Helper.hasParametersAccess(Param.P76),
        },         
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSubColors : {
          items: [],
          fields: []
        },   
        tableSubWaist : {
          items: [],
          fields: []
        },   
        tableSubColorsWaist : {
          items: [],
          fields: []
        },            
        tablePrices : {
          items: [],
          fields: []
        }, 
        tablePricesVariant : {
          items: [],
          fields: []
        }, 
        tableStock : {
          items: [],
          fields: []
        },                          
        crud: {
          form: {
            id: 0,
            name: '',
            name_short: '',
            line: null,
            line_id: 0,            
            subline: null,
            subline_id: 0,
            category: null,
            category_id: 0,            
            subcategory: null,
            subcategory_id: 0,
            customer: null,
            customer_id: 0,
            code: '',
            image: [],            
            depth: 0,
            long: 0,
            height: 0,
            weight: 0,
            attribute_colors_id: 0,
            active: true,
            featured: false,
            description: '',            
            description_short: '',     
            fileLink: '',
            file: null,
            file_name: '',
            published: true,
            fields_optionals: '',
            product_related_type_view: 'default',
            product_related_subcategory_id: 0,
            refused: false,
            variants: [],
            newVariants: '',
            erp_iva_condition: null,
            erp_iva_condition_id: 0,
            accounting_accounts: null,
            accounting_accounts_id: 0,
            videos: [],
            unit_measurement_purchase: null,
            unit_measurement_purchase_id: 0,
            unit_measurement_sale_id: 0,
            unit_measurement_sale: null,
            unit_measurement_sale_conversion: 0,
            weighable: false,
            haveCostProductPurchase: false,
            published_instagram: false,
            observations: '',
            barcode: '',
            icon_link_external: '',
            legend_link_external: '',
            link_external: '',
            order: 0,
            show_external_app: false,
            description_extended: '',            
            file1Link: '',
            file1: null,
            file1_name: '',
            file2Link: '',
            file2: null,
            file2_name: '',
            file3Link: '',
            file3: null,
            file3_name: '',  
            not_sell: false,      
            not_decimal_price_website: false,   
            product_related_specific: null,
            show_print: true,             
            max_discount: 0,
          }, 
          formSub: {
            id: 0,
            name: '',
            products: null,
            products_id: 0,
            colors: null,
            colors_id: 0,
            waist: null,
            waist_id: 0,
            code: '',
            image: [],
            description: '',   
            active: true,     
            typeVariant: '',
            show_external_app: false, 
          }, 
          formPrice: {
            id: 0,
            products_id: 0,
            price_list_id: 0,
            price_list_select: null,
            amount: 0,
            amount_old: 0,
            desc: 0,
          },   
          formPriceVariant: {
            id: 0,            
            price_list_id: 0,
            price_list_select: null,
            amount: 0,
            amount_old: 0,
            desc: 0,
          },              
          formStock: {
            id: 0,
            products_id: 0,
            stock: 0,            
            unit_measurement: null,
            unit_measurement_id: 0,
            detail: [],
          },
          formStockMinimum: {
            id: 0,
            stock_minimum: 0,
          },              
          formStockVariant: {
            id: 0,
            products_id: 0,
            stock: 0,            
          },
          formImport: {
            file: '',
            price_list: null,
            price_list_id: 0,
            type: ''            
          },
          print: {
            key: 0,
            filters: null,
            reference: 'products-price-list',
          }                                                            
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          formSub: {
            active: false,
            title: ''
          },       
          formPrice: {
            active: false,
            title: ''
          }, 
          formPriceVariant: {
            active: false,
            title: ''
          },           
          formStock: {
            active: false,
            title: ''
          },    
          formStockVariant: {
            active: false,
            title: ''
          },                                    
          formImport: {
            active: false,
            title: ''
          },
          formExport: {
            active: false,
            title: '',
            price_list: null,
            overlay: false,
          },         
        },
        arr: {
          products: [],   
          depositeZone: [],
          select:{
            listPrice: [],
            lines: [],
            sublines:[],
            categorys: [],
            subcategorys:[],
            suppliers: [],
            active:[
              {code:true, label: 'Activo'},
              {code:false, label: 'Inactivo'},              
            ],
            typeVariant: [
              { value: 'COLOR', text: 'COLOR' },
              { value: 'WAIST', text: 'TALLE' },                 
              { value: 'COLOR-WAIST', text: 'COLOR + TALLE' },                 
            ],
          }          
        },   
        filters: defaultFilters(),
        itemSelected: null,
        itemSelectedVariant: null,
        detailDrawer: false,
        showPriceEdit: false,
        showPriceVariantEdit: false,
        modulesActive: [],
        modules: {
          showPrices: false
        },
        conditionals: {
          subcategorys: [
            {field: 'category_id', condition: 0}
          ],
          lines: [
            {field: 'line_id', condition: 0}
          ]
        },
        // Panel de filtros: cerrado por default; el usuario que lo abre
        // queda con su preferencia persistida (ver watcher filtersOpen).
        filtersOpen: false,
        // stacked (modo card mobile) y sticky-header son mutuamente
        // excluyentes en BootstrapVue — stacked se activa solo cuando el
        // viewport realmente está en mobile (ver mounted/mobileMql).
        isMobileViewport: false,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.modulesActive = Session.getSession().auth.user.permissions.modules
      this.configAccess()

      this.filterLoad()
      this.loadFieldTable()
      this.loadListPrice()
      this.loadZone()

      this.filterProducts()

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_products') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      hasLines() {
        return this.parameters.haveLines
      },
      hasWaist() {
        return this.parameters.haveWaist
      },
      hasColors() {
        return this.parameters.haveColors
      },
      hasColorsWaist() {
        return this.parameters.haveColorsWaist
      },
      hasAnyVariant() {      
        return this.hasColors || this.hasWaist || this.hasColorsWaist
      },
      hasAllVariant() {      
        return this.hasColors && this.hasWaist && this.hasColorsWaist
      },      
      hasMeasurement() {
        return this.parameters.haveMeasurement
      },
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrev() {
        return this.currentIndex > 0
      },
      canGoNext() {
        if(this.currentIndex < 0) {
          return false
        }
        return this.currentIndex < (this.table.items.length - 1)
      },
      stateProductVariant() {
        return this.crud.form.variants.indexOf(this.crud.form.newVariants.trim()) > -1 ? false : null
      },
      isProcessSales() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.VENTAS || element.id == Modules.PRESUPUESTOS) {
            status = true
          }
        })
        return status
      },          
      isProcessAccounting() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },
      isProcessSellers() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.VENDEDORES) {
            status = true
          }
        })
        return status
      },
      isProcessDeposit() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.DEPOSITOS) {
            status = true
          }
        })
        return status
      },
      isCostSuppliersProducts() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.COSTOS) {
            status = true
          }
        })

        return status && !this.hasAnyVariant
      },    
      hasCostsModule() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.COSTOS) {
            status = true
          }
        })
        return status
      },
      isContents() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CONTENIDOS) {
            status = true
          }
        })
        return status
      },                

      // CONDITIONS SELECT
      conditionAccountingAccountsFilters(){
          return [
              {field: 'active', condition: true},
              {field: 'type', condition: 'Ingresos'}
          ];
      },
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_products', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación de table.fields tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      // Alineación de columna: en mobile (modo stacked) el valor pasa a
      // apilarse debajo de su label, así que la alineación de columna de
      // desktop (centrado/derecha) no tiene sentido acá — se resuelve en el
      // propio JSON de fields, en vez de pelear contra la clase con CSS.
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      // Confirm estándar: header con ícono + tinte suave (.app-confirm-header)
      // en vez de header-bg-variant sólido, size 'sm' siempre (es solo texto
      // corto), y okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Resalta la fila cuyo registro está abierto en el drawer.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el kebab de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      goPrev() {
        if(this.canGoPrev) this.openSub(this.table.items[this.currentIndex - 1])
      },
      goNext() {
        if(this.canGoNext) this.openSub(this.table.items[this.currentIndex + 1])
      },
      loadFieldTable () {
        // TABLE PRODUCTOS
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', class:"align-middle " + this.alignClass('text-center'), width:"30px"})
        this.table.fields.push({key: 'name', label: 'Nombre', class:"align-middle", width:"245px"})
        if(this.modules.showPrices) {
          this.table.fields.push({key: 'prices', label: 'Precio S/IVA', class:"align-middle", width:"150px"})
        }
        if(this.modules.showPrices && this.filters.show_price_iva) {
          this.table.fields.push({key: 'prices_iva', label: 'Precio C/IVA', class:"align-middle", width:"150px"})
        }
        if(!this.parameters.hideStock){
          this.table.fields.push({key: 'stock', label: 'Stock', class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        }
        if(this.isProcessSellers) {
          this.table.fields.push({key: 'max_discount', label: 'Desc. Max', class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        }
        if(this.hasAnyVariant) {
          this.table.fields.push({key: 'variant', label: 'Variedades', class:"align-middle " + this.alignClass('text-center'), width:"95px"})
        }
        // En mobile va como texto plano (no ícono+tooltip), así que necesita
        // un label real; en desktop es una columna angosta solo-ícono.
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"50px"})
        if(this.modules.showPrices) {
          this.table.fields.push({key: 'order', label: 'Orden', class: 'align-middle ' + this.alignClass('text-center'), width:"40px"})
        }
        this.table.fields.push({key: 'show_print', label: this.isMobileViewport ? 'Imprime' : '', class: 'align-middle ' + this.alignClass('text-center'), width:"20px"})
        // Excepción documentada: esta tabla principal conserva el campo de
        // acciones en mobile (control visible ⋮ Opciones) — ver cell(f_action).
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"20px"})

        // TABLE PRODUCTO COLOR
        this.tableSubColors.fields = []
        this.tableSubColors.fields.push({key: 'color', label: 'Color', class:"align-middle", width:"90px"})
        if(this.modules.showPrices) {
          this.tableSubColors.fields.push({key: 'prices', label: 'Precio S/IVA', class:"align-middle", width:"90px"})
        }
        if(this.modules.showPrices && this.filters.show_price_iva) {
          this.tableSubColors.fields.push({key: 'prices_iva', label: 'Precio C/IVA', class:"align-middle text-left", width:"90px"})
        }
        if(!this.parameters.hideStock){
          this.tableSubColors.fields.push({key: 'stock', label: 'Stock', class:"align-middle text-left", width:"60px"})
        }
        this.tableSubColors.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"20px"})

        // TABLE PRODUCTO TALLE
        this.tableSubWaist.fields = []
        this.tableSubWaist.fields.push({key: 'waist', label: 'Talle', class:"align-middle", width:"50px"})        
        if(this.modules.showPrices) {
          this.tableSubWaist.fields.push({key: 'prices', label: 'Precio S/IVA', class:"align-middle", width:"90px"})
        }
        if(this.modules.showPrices && this.filters.show_price_iva) {
          this.tableSubWaist.fields.push({key: 'prices_iva', label: 'Precio C/IVA', class:"align-middle text-left", width:"90px"})
        }
        if(!this.parameters.hideStock){
          this.tableSubWaist.fields.push({key: 'stock', label: 'Stock', class:"align-middle text-left", width:"60px"})
        }
        this.tableSubWaist.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"20px"})
        
        // TABLE PRODUCTO COLOR-TALLE
        this.tableSubColorsWaist.fields = []
        this.tableSubColorsWaist.fields.push({key: 'color', label: 'Color', class:"align-middle", width:"90px"})
        this.tableSubColorsWaist.fields.push({key: 'waist', label: 'Talle', class:"align-middle", width:"50px"})
        if(this.modules.showPrices) {
          this.tableSubColorsWaist.fields.push({key: 'prices', label: 'Precio S/IVA', class:"align-middle", width:"90px"})
        }
        if(this.modules.showPrices && this.filters.show_price_iva) {
          this.tableSubColorsWaist.fields.push({key: 'prices_iva', label: 'Precio C/IVA', class:"align-middle text-left", width:"90px"})
        }
        if(!this.parameters.hideStock){
          this.tableSubColorsWaist.fields.push({key: 'stock', label: 'Stock', class:"align-middle text-left", width:"60px"})
        }
        this.tableSubColorsWaist.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"20px"})

        // TABLE MODAL PRICE
        this.tablePrices.fields = []
        this.tablePrices.fields.push({key: 'list', label: 'Lista', class:"align-middle", width:"20%"})
        this.tablePrices.fields.push({key: 'price_list', label: '', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        this.tablePrices.fields.push({key: 'price_public', label: 'Precio', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        this.tablePrices.fields.push({key: 'desc', label: 'Descuento', class:"align-middle " + this.alignClass('text-right'), width:"10%"})
        this.tablePrices.fields.push({key: 'price_desc', label: 'Precio S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        if(this.filters.show_price_iva) {
          this.tablePrices.fields.push({key: 'price_iva', label: 'Precio C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        }
        this.tablePrices.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"10%"})

        // TABLE MODAL PRICE VARIANT
        this.tablePricesVariant.fields = []
        this.tablePricesVariant.fields.push({key: 'list', label: 'Lista', class:"align-middle", width:"30%"})
        this.tablePricesVariant.fields.push({key: 'price', label: 'Precio', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        this.tablePricesVariant.fields.push({key: 'desc', label: 'Descuento', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        this.tablePricesVariant.fields.push({key: 'price_desc', label: 'Precio S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        if(this.filters.show_price_iva) {
          this.tablePricesVariant.fields.push({key: 'price_iva', label: 'Precio C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        }
        this.tablePricesVariant.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"10%"})

        // TABLE STOCK
        this.tableStock.fields = []
        this.tableStock.fields.push({key: 'deposit', label: 'Deposito', class:"align-middle", width:"250px"})
        this.tableStock.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-center'), width:"100px"})
      },
      getRowCount (items) {
        return items.length
      },
      openDetail(index) {
        this.table.rowSelected = index          
        this.filterProducts()        
      },       
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerProducto()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arr.products = data

          this.table.items.forEach(element => {
            if(!element.active) {
              element._rowVariant = 'danger'  
            }
          });
          
          if(this.table.rowSelected!=null) {
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }  
          loader.hide()         
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });        
      },
      loadListPrice() {
        var result = serviceAPI.obtenerListaPreciosSimple()        

        result.then((response) => {
          var data = response.data    

          data.forEach(element => {
            this.arr.select.listPrice.push({
              code: element.id,
              label: element.name
            })  
          });    
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error))
        });        
      },
      configAccess() {
        this.modulesActive.forEach(element => {          
          if(element.id == Modules.PRECIOS) {                          
            this.modules.showPrices = true                             
          }
        })
      },
  
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.name_short = ''
        this.crud.form.line_id = 0    
        this.crud.form.subline_id = 0    
        this.crud.form.category_id = 0  
        this.crud.form.subcategory_id = 0
        this.crud.form.customer_id = 0
        this.crud.form.code = ''
        this.crud.form.image = []        
        this.crud.form.depth = 0
        this.crud.form.long = 0
        this.crud.form.height = 0
        this.crud.form.weight = 0
        this.crud.form.attribute_colors_id = 0
        this.crud.form.active = true
        this.crud.form.featured = false
        this.crud.form.description = ''        
        this.crud.form.description_short = ''        
        this.crud.form.file = null
        this.crud.form.fileLink = ''
        this.crud.form.file_name = ''
        this.crud.form.published = true
        this.crud.form.product_related_type_view = 'default'
        this.crud.form.product_related_subcategory_id = 0
        this.crud.form.refused = false
        this.crud.form.published_instagram = false
        this.crud.form.observations = ''
        this.crud.form.barcode = ''
        this.crud.form.icon_link_external = ''
        this.crud.form.legend_link_external = ''
        this.crud.form.link_external = ''
        this.crud.form.order = 0
        this.crud.form.show_external_app = false
        this.crud.form.description_extended = ''
        this.crud.form.file1 = null
        this.crud.form.file1Link = ''
        this.crud.form.file1_name = ''
        this.crud.form.file2 = null
        this.crud.form.file2Link = ''
        this.crud.form.file2_name = ''
        this.crud.form.file3 = null
        this.crud.form.file3Link = ''
        this.crud.form.file3_name = ''
        this.crud.form.not_sell = false
        this.crud.form.not_decimal_price_website = false
        this.crud.form.product_related_specific = null        
        this.crud.form.show_print= true
        this.crud.form.max_discount = 0
        
        this.crud.form.variants = []
        this.crud.form.newVariants = ''

        this.crud.form.erp_iva_condition = null
        this.crud.form.erp_iva_condition_id = 0

        this.crud.form.accounting_accounts = null
        this.crud.form.accounting_accounts_id = 0

        this.videosTMP = []
        
        this.crud.form.unit_measurement_purchase = null
        this.crud.form.unit_measurement_purchase_id = 0
        this.crud.form.unit_measurement_sale = null
        this.crud.form.unit_measurement_sale_id = 0
        this.crud.form.unit_measurement_sale_conversion = 0
        this.crud.form.haveCostProductPurchase = false

        this.showPriceEdit = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Producto"
        this.modal.form.active = true
      },
      edit(item) {
        let loader = this.$loading.show();

        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.name_short = item.name_short
                
        if(item.subline) {
          this.crud.form.line_id = item.subline.line_id
          this.setConditionalSubLine(item.subline.line_id)          
          this.crud.form.subline_id =  item.subline_id        
        } else {
          this.crud.form.line_id = 0
          this.setConditionalSubLine(0)
          this.crud.form.subline_id = 0            
        }
        
        if(item.subcategory) {
          this.crud.form.category_id = item.subcategory.category_id
          this.setConditionalSubCategory(item.subcategory.category_id)
          this.crud.form.subcategory_id = item.subcategory_id
        } else {
          this.crud.form.category_id = 0
          this.setConditionalSubCategory(0)
          this.crud.form.subcategory_id = 0          
        }

        this.crud.form.customer_id = item.customer_id
        this.crud.form.code = item.code
        this.crud.form.image = item.image        
        this.crud.form.depth = item.depth
        this.crud.form.long = item.long
        this.crud.form.height = item.height
        this.crud.form.weight = item.weight
        this.crud.form.attribute_colors_id = (item.attribute_colors_id!=null) ? item.attribute_colors_id : 0
        this.crud.form.active = item.active
        this.crud.form.featured = item.featured
        this.crud.form.description = item.description      
        this.crud.form.description_short = (item.description_short!=null) ? item.description_short : ''
        this.crud.form.file = null
        this.crud.form.fileLink = item.attach              
        this.crud.form.file_name = (item.attach_name!=null) ? item.attach_name : ''          
        this.crud.form.published = item.published
        this.crud.form.product_related_type_view = (item.product_related_type_view!=null) ? item.product_related_type_view : 'default'
        this.crud.form.product_related_subcategory_id = (item.product_related_subcategory_id!=null) ? item.product_related_subcategory_id : 0
        this.crud.form.refused = item.refused
        this.crud.form.published_instagram = item.published_instagram
        this.crud.form.observations = (item.observations!=null) ? item.observations : ''
        this.crud.form.barcode = (item.barcode!=null) ? item.barcode : ''
        this.crud.form.icon_link_external = (item.icon_link_external!=null) ? item.icon_link_external : ''
        this.crud.form.legend_link_external = (item.legend_link_external!=null) ? item.legend_link_external : ''
        this.crud.form.link_external = (item.link_external!=null) ? item.link_external : ''
        this.crud.form.order = item.order
        this.crud.form.show_external_app = item.show_external_app
        this.crud.form.description_extended = (item.description_extended!=null) ? item.description_extended : ''
        this.crud.form.file1 = null
        this.crud.form.file1Link = item.attach_one
        this.crud.form.file1_name = (item.attach_one_name!=null) ? item.attach_one_name : ''
        this.crud.form.file2 = null
        this.crud.form.file2Link = item.attach_two
        this.crud.form.file2_name = (item.attach_two_name!=null) ? item.attach_two_name : ''
        this.crud.form.file3 = null
        this.crud.form.file3Link = item.attach_three
        this.crud.form.file3_name = (item.attach_three_name!=null) ? item.attach_three_name : ''
        this.crud.form.not_sell = item.not_sell
        this.crud.form.not_decimal_price_website = item.not_decimal_price_website
        this.crud.form.product_related_specific = item.product_related_specific ? item.product_related_specific : null        
        this.crud.form.show_print = item.show_print
        this.crud.form.max_discount = (item.max_discount != null && item.max_discount !== '') ? item.max_discount : 0

        if(item.variants) {
          this.crud.form.variants = item.variants.split(',')
          this.crud.form.newVariants = ''
        } else {
          this.crud.form.variants = []
          this.crud.form.newVariants = ''          
        }
                
        if(item.image) {          
          this.crud.form.image = []
          item.image.forEach(element => {
            this.crud.form.image.push({ path: element })
          });                    
        } else {
          this.crud.form.image = []
        }

        this.videosTMP = []
        if(item.videos)
          this.videosTMP = JSON.parse(item.videos)
                                
        if(item.product_purchase) {
          this.crud.form.unit_measurement_purchase = item.product_purchase.unit_measurement_purchase
          this.crud.form.unit_measurement_purchase_id = item.product_purchase.unit_measurement_purchase_id
          this.crud.form.haveCostProductPurchase = true
        } else {
          this.crud.form.unit_measurement_purchase = item.unit_measurement_purchase
          this.crud.form.unit_measurement_purchase_id = item.unit_measurement_purchase_id
          this.crud.form.haveCostProductPurchase = false
        }

        this.crud.form.unit_measurement_sale = item.unit_measurement_sale
        this.crud.form.unit_measurement_sale_id = item.unit_measurement_sale_id 
        this.crud.form.unit_measurement_sale_conversion = item.unit_measurement_sale_conversion
        this.crud.form.weighable = !!item.weighable

        this.crud.form.erp_iva_condition = item.erp_iva_condition
        this.crud.form.erp_iva_condition_id = item.erp_iva_condition_id

        this.crud.form.accounting_accounts = item.accounting_account
        this.crud.form.accounting_accounts_id = item.accounting_accounts_id

        this.showPriceEdit = true
        this.tablePrices.items = item.prices

        setTimeout(()=>{
          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = "Editar Producto"
          this.modal.form.active = true

          loader.hide()
        },500)
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Producto',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarProducto(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              if(this.itemSelected && this.itemSelected.id === item.id) {
                this.hideSub()
              }
              loader.hide()
              this.filterProducts()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        var image = new FormData();
        this.crud.form.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var file = new FormData();
        if(this.crud.form.fileLink) {
          file.append("file", this.crud.form.fileLink);
        } else {        
          if(this.crud.form.file) {          
            file.append("file", this.crud.form.file);
          }
        }  
        var file1 = new FormData();
        if(this.crud.form.file1Link) {
          file1.append("file1", this.crud.form.file1Link);
        } else {        
          if(this.crud.form.file1) {          
            file1.append("file1", this.crud.form.file1);
          }
        }          
        var file2 = new FormData();
        if(this.crud.form.file2Link) {
          file2.append("file2", this.crud.form.file2Link);
        } else {        
          if(this.crud.form.file2) {          
            file2.append("file2", this.crud.form.file2);
          }
        }          
        var file3 = new FormData();
        if(this.crud.form.file3Link) {
          file3.append("file3", this.crud.form.file3Link);
        } else {        
          if(this.crud.form.file3) {          
            file3.append("file3", this.crud.form.file3);
          }
        }  

        this.crud.form.fields_optionals = []

        this.crud.form.videos = JSON.stringify(this.videosTMP)
        if(!this.parameters.enableProductShortName) {
          this.crud.form.name_short = this.crud.form.name
        }

        if (this.crud.form.id) {
          var result = serviceAPI.editarProducto(JSON.stringify(this.crud.form), image, file, file1, file2, file3);
        } else {
          var result = serviceAPI.agregarProducto(JSON.stringify(this.crud.form), image, file, file1, file2, file3);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.filterProducts()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      showParseReferenceExternal(item) {                               
        let html = ""                
        if(item.subcategory && item.subcategory.category) {
          html = html + "" + item.subcategory.category.name + " > " + item.subcategory.name + "<hr>";                
        }        
        if(item.subline && item.subline.line) {
          html = html + "<b>LINEA:</b> " + item.subline.line.name + ' <br> ' + item.subline.name + "<hr>";              
        }                
        html = html + "<b>" + item.code + "</b><br>" + item.name + "<br>";        
        if(item.barcode) {
          html = html + "<hr>" + "<b>CODIGO DE BARRA:</b> <br>" + item.barcode;        
        }
        return html
      },
      
      openImportCSV() {
        this.crud.formImport.type = 'import_store_products'
        this.crud.formImport.file = ''
        this.crud.formImport.price_list = null
        this.crud.formImport.price_list_id = 0
            
        this.modal.formImport._id = Math.random().toString(36).slice(2, 8)
        this.modal.formImport.title = "Gestor de Importaciones"
        this.modal.formImport.active = true
      },      
      importCSV() {
        this.confirmDialog('¿Continuar con la importación?', {
          title: 'Importar desde CSV',
          okTitle: 'IMPORTAR'
        })
        .then(value => {
          if (value) {            
            let loader = this.$loading.show();

            var file = new FormData();
            file.append("file", this.crud.formImport.file);
            
            var type = ''
            if(!this.hasAnyVariant) {
              type = 'product'
            }          
            if(this.hasColors && !this.hasColorsWaist) {
              type = 'product-colors'
            }                   
            if(this.hasWaist && !this.hasColorsWaist) {
              type = 'product-waist'
            }               
            if(this.hasColorsWaist) {
              type = 'product-colors-waist'
            }                                                  
            
            if(this.crud.formImport.type == 'import_store_products') {    
              var result = serviceAPI.importarProductos(JSON.stringify(this.crud.formImport), file, type);
            }            
            if(this.crud.formImport.type == 'import_update_products_prices') {
              var result = serviceAPI.importarUpdateProductosPrices(JSON.stringify(this.crud.formImport), file, type);
            }
                    
            result.then((response) => {
              this.modal.formImport.active = false
              loader.hide()
              this.filterProducts()
              this.$awn.success("Archivo importado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })        
      },
      goDownloadFormat(value) {
        var win = window.open(Helper.getPathPublic(value), '_blank');        
        win.focus();
      },

      addSub(item) {                
        this.crud.formSub.id = 0       
        this.crud.formSub.name = item.name
        this.crud.formSub.products_id = item.id
        this.crud.formSub.colors_id = 0
        this.crud.formSub.waist_id = 0
        this.crud.formSub.code = item.code
        this.crud.formSub.image = []
        this.crud.formSub.description = ''   
        this.crud.formSub.active = true
        this.crud.formSub.show_external_app = false

        if(this.hasColorsWaist) {
          this.crud.formSub.typeVariant = 'COLOR-WAIST'
        } else {
          if(this.hasColors) {
            this.crud.formSub.typeVariant = 'COLOR'
          } else {
            this.crud.formSub.typeVariant = 'WAIST'
          }
        }

        this.showPriceVariantEdit = false

        this.modal.formSub.title = "Nueva Variedad"
        this.modal.formSub.active = true
      },
      editSub(item) {
        this.crud.formSub.id = item.id        
        this.crud.formSub.name = item.name           
        this.crud.formSub.products_id = item.products_id
        this.crud.formSub.colors_id = item.colors_id
        this.crud.formSub.waist_id = item.waist_id
        this.crud.formSub.code = item.code
        this.crud.formSub.image = item.image
        this.crud.formSub.description = item.description
        this.crud.formSub.active = item.active
        this.crud.formSub.show_external_app = item.show_external_app

        if(this.hasColorsWaist) {
          this.crud.formSub.typeVariant = 'COLOR-WAIST'
        } else {
          if(this.hasColors) {
            this.crud.formSub.typeVariant = 'COLOR'
          } else {
            this.crud.formSub.typeVariant = 'WAIST'
          }
        }

        if(item.image) {          
          this.crud.formSub.image = []
          item.image.forEach(element => {
            this.crud.formSub.image.push({ path: element })
          });                    
        } else {
          this.crud.formSub.image = []
        }

        this.showPriceVariantEdit = true
        this.tablePricesVariant.items = item.prices

        this.modal.formSub.title = "Editar Variedad"
        this.modal.formSub.active = true
      },
      removeSub(item) {
        this.crud.formSub.id = item.id
        this.crud.formSub.name = item.name        

        if(this.hasColorsWaist) {
          this.crud.formSub.typeVariant = 'COLOR-WAIST'
        } else {
          if(this.hasColors) {
            this.crud.formSub.typeVariant = 'COLOR'
          } else {
            this.crud.formSub.typeVariant = 'WAIST'
          }
        }

        this.confirmDialog('¿Desea borrar el item (' + this.crud.formSub.id + ') - '+ this.crud.formSub.name + '?', {
          title: 'Borrar Variedad',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var typeVariant = this.getTypeVariant()                       
            var result = serviceAPI.eliminarVariedad(this.crud.formSub.id, typeVariant);

            result.then((response) => {      
              this.modal.formSub.active = false        
              this.filterProducts(true)     
              loader.hide()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },
      saveSub() {
        let loader = this.$loading.show();

        var image = new FormData();
        this.crud.formSub.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var typeVariant = this.getTypeVariant()

        if (this.crud.formSub.id) {
          var result = serviceAPI.editarVariedad(JSON.stringify(this.crud.formSub), image, typeVariant);
        } else {
          var result = serviceAPI.agregarVariedad(JSON.stringify(this.crud.formSub), image, typeVariant);
        }

        result.then((response) => {
          this.modal.formSub.active = false                   
          this.filterProducts(true)     
          loader.hide()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },      

      loadProductsLine (object) {
        if(object){
          this.crud.form.line = object
          this.crud.form.line_id = object.id
          //this.crud.form.subline = null
          //this.crud.form.subline_id = 0

          this.setConditionalSubLine(object.id)
        } else {
          this.crud.form.line = null
          this.crud.form.line_id = 0
          //this.crud.form.subline = null
          //this.crud.form.subline_id = 0

          this.setConditionalSubLine(object.id)
        }
      },  
      loadProductsSubline (object) {
        if(object){
          this.crud.form.subline = object
          this.crud.form.subline_id = object.id
        } else {
          this.crud.form.subline = null
          this.crud.form.subline_id = 0
        }
      },  
      loadProductsCategory (object) {
        if(object){
          this.crud.form.category = object
          this.crud.form.category_id = object.id    
          //this.crud.form.subcategory = null
          //this.crud.form.subcategory_id = 0

          this.setConditionalSubCategory(object.id)
        } else {
          this.crud.form.category = null
          this.crud.form.category_id = 0
          //this.crud.form.subcategory = null
          //this.crud.form.subcategory_id = 0          

          this.setConditionalSubCategory(0)
        }
      },               
      loadProductsSubcategory (object) {
        if(object){
          this.crud.form.subcategory = object
          this.crud.form.subcategory_id = object.id

          this.loadSubcategoryTypeView(object)
          
        } else {
          this.crud.form.subcategory = null
          this.crud.form.subcategory_id = 0

          this.loadSubcategoryTypeView(null)
        }
      },   
      loadVarietyProducts (object) {
        if(object){
          this.crud.formSub.products = object
          this.crud.formSub.products_id = object.id
        } else {
          this.crud.formSub.products = null
          this.crud.formSub.products_id = 0
        }
      }, 
      loadVarietyColors (object) {
        if(object){
          this.crud.formSub.colors = object
          this.crud.formSub.colors_id = object.id
        } else {
          this.crud.formSub.colors = null
          this.crud.formSub.colors_id = 0
        }
      }, 
      loadVarietyWaist (object) {
        if(object){
          this.crud.formSub.waist = object
          this.crud.formSub.waist_id = object.id
        } else {
          this.crud.formSub.waist = null
          this.crud.formSub.waist_id = 0
        }
      },
      loadSubcategoryTypeView (object) {
        if(object) {
          var result = serviceAPI.mostrarCategoria(object.category_id)

          result.then((response) => {
            var data = response.data              

            if(data.subcategorys) {            
              this.optProductRelatedSubcategory = []
              data.subcategorys.forEach(element => {      
                this.optProductRelatedSubcategory.push({text: element.name, value: element.id})                                                            
              });                                
            }          
          })         
        } else {
          this.optProductRelatedSubcategory = []
        }
      },
      loadListPriceImportCSV (object) {
        if(object){
          this.crud.formImport.price_list = object
          this.crud.formImport.price_list_id = object.id
        } else {
          this.crud.formImport.price_list = null
          this.crud.formImport.price_list_id = 0
        }
      },       
      loadIvaConditions (object) {
          if(object){
              this.crud.form.erp_iva_condition = object
              this.crud.form.erp_iva_condition_id = object.id             
          } else {
              this.crud.form.erp_iva_condition = null
              this.crud.form.erp_iva_condition_id = 0
          }
      },      
      loadAccountingAccounts (object) {
          if(object){
              this.crud.form.accounting_accounts = object
              this.crud.form.accounting_accounts_id = object.id             
          } else {
              this.crud.form.accounting_accounts = null
              this.crud.form.accounting_accounts_id = 0
          }
      },
      loadUnitMeasurementSale(object) {
        if(object){
          this.crud.form.unit_measurement_sale = object
          this.crud.form.unit_measurement_sale_id = object.id             
        } else {
          this.crud.form.unit_measurement_sale = null
          this.crud.form.unit_measurement_sale_id = 0
        }
      },
      loadUnitMeasurementPurchase(object) {
        if(object){
          this.crud.form.unit_measurement_purchase = object
          this.crud.form.unit_measurement_purchase_id = object.id             
        } else {
          this.crud.form.unit_measurement_purchase = null
          this.crud.form.unit_measurement_purchase_id = 0
        }
      },      
      
      setConditionalSubLine(id) {
        this.conditionals.sublines = [
          {field: 'line_id', condition: id},
        ]      
      },      
      setConditionalSubCategory(id) {
        this.conditionals.subcategorys = [
          {field: 'category_id', condition: id},
        ]      
      },

      filterLoad() {
        this.filterLoadLines()
        this.filterLoadCategorys()

        this.restoreFilterStorage() 

        if(this.hasCostsModule) {
          this.filterLoadSuppliers()
        } else if(this.filters.supplier) {
          this.filters.supplier = null
          this.saveFilterStorage()
        }
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedoresConProductos()
        result.then((response) => {
          var data = response.data.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))

          this.arr.select.suppliers = []
          data.forEach(element => {
            if(element && element.id) {
              this.arr.select.suppliers.push({
                code: element.id,
                label: element.name
              })
            }
          })

          this.syncFilterSupplier()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      filterLoadLines() {
        var result = serviceAPI.obtenerLinea()        
        result.then((response) => {
          var data = response.data    
          
          data.forEach(element => {      
            this.arr.select.lines.push({code: element.id, label: element.name})                                                            
          });                                
        })   
      },
      filterLoadSubLines(val) {        
        this.arr.select.sublines=[]
        if(val) {
          var result = serviceAPI.obtenerLinea()        
          result.then((response) => {
            var data = response.data    
            
            data.forEach(element => {         
              if(element.id == val.code) {
                element.sublines.forEach(element1 => {
                  this.arr.select.sublines.push({code: element1.id, label: element1.name})                        
                }); 
              }
            });                                
          })   
        }
      },
      filterLoadCategorys() {
        var result = serviceAPI.obtenerCategoria()        
        result.then((response) => {
          var data = response.data    

          data.forEach(element => {              
            this.arr.select.categorys.push({code: element.id, label: element.name})
          });                                
        })   
      },   
      filterLoadSubCategorys(val) {
        this.arr.select.subcategorys = []
        if(val) {          
          var result = serviceAPI.obtenerCategoria()        
          result.then((response) => {
            var data = response.data    

            data.forEach(element => {          
              if(element.id == val.code) {
                element.subcategorys.forEach(element1 => {                
                  this.arr.select.subcategorys.push({code: element1.id, label: element1.name})
                }); 
              }                                  
            });                                
          })   
        }
      },

      filterProducts(forceOpenVariant=false, forceOpenPricesProducts=false, forceOpenPricesProductsVariant=false, forceOpenStock=false, forceOpenStockVariant=false) {
        this.filters.listFullToCSV = false
        this.filters.price_list_id = 0
        this.filters.last_update_days = 0
        this.filters.hide_price_zero = false
        this.saveFilterStorage()

        this.table.isBusy = true
        var result = serviceAPI.filtrarProducto(this.filters, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data
          this.table.items = data.data          
          this.arr.products = data.data  

          this.table.items.forEach(element => {
            if(!element.active) {
              element._rowVariant = 'danger'                          
            }
            
            if(forceOpenVariant) {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }
            }

            if(forceOpenPricesProducts) {
              if(element.id == this.itemSelected.id) {
                this.setPricesProducts(element)
              }              
            }  

            if(forceOpenPricesProductsVariant) {
              if(element.id == this.itemSelected.id) {
                if(element.colors) {
                  element.colors.forEach(element1 => {
                    if(element1.id == this.itemSelectedVariant.id) {
                      this.setPricesProductsVariant(element1)
                    }
                  });
                }                

                if(element.waist) {
                  element.waist.forEach(element2 => {
                    if(element2.id == this.itemSelectedVariant.id) {
                      this.setPricesProductsVariant(element2)
                    }
                  });             
                }   

                if(element.colors_waist) {
                  element.colors_waist.forEach(element3 => {
                    if(element3.id == this.itemSelectedVariant.id) {
                      this.setPricesProductsVariant(element3)
                    }
                  });                    
                }            
              }              
            }

            if(forceOpenStock) {
              if(element.id == this.itemSelected.id) {
                this.setStockProducts(element)
              }              
            }  

            if(forceOpenStockVariant) {
              if(element.id == this.itemSelected.id) {
                if(element.colors) {
                  element.colors.forEach(element1 => {
                    if(element1.id == this.itemSelectedVariant.id) {
                      this.setStockProductsVariant(element1)
                    }
                  });
                }                

                if(element.waist) {
                  element.waist.forEach(element2 => {
                    if(element2.id == this.itemSelectedVariant.id) {
                      this.setStockProductsVariant(element2)
                    }
                  });             
                }   

                if(element.colors_waist) {
                  element.colors_waist.forEach(element3 => {
                    if(element3.id == this.itemSelectedVariant.id) {
                      this.setStockProductsVariant(element3)
                    }
                  });                    
                }            
              }                                 
            }
          });

          if(this.table.rowSelected!=null) {            
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }   
                    
          if(this.$refs.table) {            
            this.$refs.table.$forceUpdate()
          }          
          
          this.loadFieldTable()            

          this.table.isBusy = false
        })           
        .catch(error => {  
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })  
      },

      getTypeVariant() {
        var typeVariant = ''
        if(this.hasAllVariant) {          
          if(this.crud.formSub.typeVariant=='COLOR') {
            typeVariant = 'COLOR'
          }
          if(this.crud.formSub.typeVariant=='WAIST') {
            typeVariant = 'WAIST'
          }   
          if(this.crud.formSub.typeVariant=='COLOR-WAIST') {
            typeVariant = 'COLOR-WAIST'
          }                    
        } else {        
          if(this.hasColors) {
            typeVariant = 'COLOR'
          }

          if(this.hasWaist) {
            typeVariant = 'WAIST'
          }          

          if(this.hasColorsWaist) {
            typeVariant = 'COLOR-WAIST'
          }          
        }
        return typeVariant
      },
      getTypeVariantAlt() {
        var typeVariant = ''        
        if(this.hasAnyVariant) {                        
          if(this.hasColors) {
            typeVariant = 'COLOR'
          }

          if(this.hasWaist) {
            typeVariant = 'WAIST'
          }          

          if(this.hasColorsWaist) {
            typeVariant = 'COLOR-WAIST'
          }          
        }
        return typeVariant
      },
      getVariantProduct(item) {
        if(!item) {
          return false
        }        

        return !!(
          (item.colors && item.colors.length) ||
          (item.waist && item.waist.length) ||
          (item.colors_waist && item.colors_waist.length)
        )
      },      
      productControlsStock(item) {
        if(!item) {
          return true
        }

        var value = null
        if(Object.prototype.hasOwnProperty.call(item, 'control_stock')) {
          value = item.control_stock
        } else if(item.product && Object.prototype.hasOwnProperty.call(item.product, 'control_stock')) {
          value = item.product.control_stock
        } else {
          return true
        }

        return !(value === false || value === 0 || value === '0')
      },
      canManageStockProduct(item) {
        return !!(item && !this.parameters.hideStock && !this.getVariantProduct(item) && this.productControlsStock(item))
      },
      canManageStockVariant() {
        return !!(!this.parameters.hideStock && this.productControlsStock(this.itemSelected))
      },

      openSub(item) {
        this.itemSelected = item
        this.detailDrawer = true

        this.tableSubColors.items = item.colors
        this.tableSubColors.items.forEach(element => {
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });          
      
        this.tableSubWaist.items = item.waist
        this.tableSubWaist.items.forEach(element => {
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });           
      
        this.tableSubColorsWaist.items = item.colors_waist
        this.tableSubColorsWaist.items.forEach(element => {            
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });
      },
      hideSub() {
        this.itemSelected = null
        this.detailDrawer = false
      },

      sumDiscountPrice(amount, desc, item = null, action = 'viewCalc') {
        if(item && item.unit_measurement_initial && item.unit_measurement_result && item.unit_measurement_initial.id != item.unit_measurement_result.id) {        
          if(action == 'viewCalc') {           
            if(parseFloat(item.amount_initial) == parseFloat(amount)) {
              return parseFloat(item.amount_initial)
            } else {
              if(desc) {
                var base1 = (100 - parseFloat(desc)) / 100                
                if(parseFloat(base1) == 0) {                            
                  return parseFloat(amount)
                } else {                              
                  return parseFloat(amount) / base1
                }                        
              } else {            
                return parseFloat(amount)
              }
            }          
          } 
          
          if(action == 'formEdit') {           
            return parseFloat(amount)
          }
        } else {    
          if(action == 'viewCalc') {        
            if(desc) {
              var base2 = (100 - parseFloat(desc)) / 100                
              if(parseFloat(base2) == 0) {                            
                return parseFloat(amount)
              } else {              
                return parseFloat(amount) / base2
              }                        
            } else {            
              return parseFloat(amount)
            }   
          }

          if(action == 'formEdit') {           
            return parseFloat(amount)
          }          
        }     
      },
      setPricesProducts(item) {
        this.crud.formPrice.id = 0
        this.crud.formPrice.products_id = item.id
        this.crud.formPrice.price_list_select = null
        this.crud.formPrice.price_list_id = null
        this.crud.formPrice.amount = 0
        this.crud.formPrice.amount_old = 0
        this.crud.formPrice.desc = 0

        this.tablePrices.items = item.prices
        this.itemSelected = item

        this.modal.formPrice.active = true
        this.modal.formPrice.title = "Mantenimiento de Precios"
      },
      editPricesProducts(item) {
        this.crud.formPrice.id = item.id
        this.crud.formPrice.products_id = item.products_id
        this.crud.formPrice.price_list_select = { code: item.list.id, label: item.list.name}
        this.crud.formPrice.price_list_id = item.list.id
        this.crud.formPrice.amount = this.sumDiscountPrice(item.amount_initial, item.desc, item, 'formEdit').toFixed(2)      
        this.crud.formPrice.amount_old = this.sumDiscountPrice(item.amount_initial, item.desc, item, 'formEdit').toFixed(2)
        this.crud.formPrice.desc = item.desc
      },
      cancelSaveFormPrice(){
        this.crud.formPrice.id = 0
        this.crud.formPrice.price_list_select = null
        this.crud.formPrice.price_list_id = null
        this.crud.formPrice.amount = 0
        this.crud.formPrice.amount_old = 0
        this.crud.formPrice.desc = 0
      },
      removePricesProducts(item) {
        var id = item.id
        var listName = 'LISTA: ' + item.list.name        
        var listAmount = 'PRECIO: ' + Intl.NumberFormat('es-AR',{style:'currency',currency:item.list.currency.code}).format(item.amount_total)

        this.confirmDialog('¿Desea borrar el item de la ' + listName + ' con ' + listAmount + '?', {
          title: 'Borrar Precio',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.eliminarPrecioVariedad(id);

            result.then((response) => {      
              loader.hide()
              this.filterProducts(false, true)
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          } 
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },
      saveFormPrice(){
        let loader = this.$loading.show();

        if(this.crud.formPrice.price_list_select) {
          this.crud.formPrice.price_list_id = this.crud.formPrice.price_list_select.code
        }        

        if (this.crud.formPrice.id) {
          var result = serviceAPI.editarPrecioVariedad(this.crud.formPrice)
        } else {
          var result = serviceAPI.agregarPrecioVariedad(this.crud.formPrice)
        }

        result.then((response) => {                         
          loader.hide()
          this.filterProducts(true, true)          
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      
      setPricesProductsVariant(item) {        
        this.crud.formPriceVariant.id = 0        
        this.crud.formPriceVariant.price_list_select = null
        this.crud.formPriceVariant.price_list_id = null
        this.crud.formPriceVariant.amount = 0
        this.crud.formPriceVariant.amount_old = 0
        this.crud.formPriceVariant.desc = 0

        this.tablePricesVariant.items = item.prices
        this.itemSelectedVariant = item

        this.modal.formPriceVariant.active = true
        this.modal.formPriceVariant.title = "VARIEDAD - Mantenimiento de Precios"
      },
      editPricesProductsVariant(item) {
        this.crud.formPriceVariant.id = item.id        
        this.crud.formPriceVariant.price_list_select = { code: item.list.id, label: item.list.name}
        this.crud.formPriceVariant.price_list_id = item.list.id
        this.crud.formPriceVariant.amount = this.sumDiscountPrice(item.amount_total, item.desc, item).toFixed(2)
        this.crud.formPriceVariant.amount_old = this.sumDiscountPrice(item.amount_total, item.desc, item).toFixed(2)
        this.crud.formPriceVariant.desc = item.desc
      },
      cancelSaveFormPriceVariant(){
        this.crud.formPriceVariant.id = 0
        this.crud.formPriceVariant.price_list_select = null
        this.crud.formPriceVariant.price_list_id = null
        this.crud.formPriceVariant.amount = 0
        this.crud.formPriceVariant.amount_old = 0
        this.crud.formPriceVariant.desc = 0
      },
      saveFormPriceVariant(){
        let loader = this.$loading.show(); 

        if (!this.crud.formPriceVariant.id) { 
          this.$awn.alert(Error.showError("No se cargo el item"));
          return false
        }

        var result = serviceAPI.editarPrecioVariedadItem(this.crud.formPriceVariant)        

        result.then((response) => {                         
          loader.hide()
          this.filterProducts(true, false, true)          
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },

      setStockProducts(item) {
        if(!this.productControlsStock(item)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        // set stock minimo
        this.crud.formStockMinimum.id = item.id
        this.crud.formStockMinimum.stock_minimum = item.stock_minimum

        // set stock
        this.crud.formStock.id = item.id
        this.crud.formStock.products_id = item.id
        this.crud.formStock.stock = item.stock

        this.crud.formStock.unit_measurement = item.unit_measurement_purchase_default
        this.crud.formStock.unit_measurement_id = item.unit_measurement_purchase_default.id

        this.crud.formStock.detail = []
        this.tableStock.items = []

        this.itemSelected = item

        var openModal = () => {
          this.modal.formStock.active = true

          if(this.isProcessDeposit) {
            this.modal.formStock.title = "Stock"
          } else {
            this.modal.formStock.title = "Mantenimiento de Stock"
          }
        }

        if(!this.isProcessDeposit) {
          openModal()
          return
        }

        // El detalle por depósito ya no viene en el listado (se sacó de ahí
        // porque se recalculaba para cada fila aunque no se mostrara) — se
        // pide puntual al abrir este modal.
        let loader = this.$loading.show();
        var result = serviceAPI.mostrarProducto(item.id)

        result.then((response) => {
          var data = response.data
          if(data.depositLocationDetail) {
            data.depositLocationDetail.forEach(element => {
              this.crud.formStock.detail.push({
                'deposit': element.location ? element.location.full_reference : '',
                'location': element.location || null,
                'quantity': element.quantity,
                'unit_measurement': this.crud.formStock.unit_measurement,
              })
            });
          }
          this.tableStock.items = this.crud.formStock.detail

          loader.hide()
          openModal()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      saveFormStock(){
        if(!this.productControlsStock(this.itemSelected)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        this.confirmDialog('Desea continuar con la actualización de stock?', {
          title: 'Actualizar Stock',
          icon: 'box',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {

            let loader = this.$loading.show();

            if (!this.crud.formStock.id) { 
              this.$awn.alert(Error.showError("No se cargo el item"));
              return false
            }
            
            var result = serviceAPI.editarProductStock(this.crud.formStock)
            
            result.then((response) => {                         
              loader.hide()
              this.filterProducts(true, false, false, true, false)
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })     
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })           
      },
      saveFormStockMinimum(){
        if(!this.productControlsStock(this.itemSelected)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        this.confirmDialog('Actualizar el stock mínimo?', {
          title: 'Actualizar Stock Mínimo',
          icon: 'box',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {

            let loader = this.$loading.show();

            if (!this.crud.formStockMinimum.id) { 
              this.$awn.alert(Error.showError("No se cargo el item"));
              return false
            }
            
            var result = serviceAPI.editarProductStockMinimum(this.crud.formStockMinimum)
            
            result.then((response) => {                         
              loader.hide()
              this.filterProducts(true, false, false, true, false)          
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })     
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })           
      },

      setStockProductsVariant(item) {
        if(!this.productControlsStock(this.itemSelected)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        // set stock minimo
        this.crud.formStockMinimum.id = item.id
        this.crud.formStockMinimum.stock_minimum = item.stock_minimum

        // set stock
        this.crud.formStockVariant.id = item.id
        this.crud.formStockVariant.stock = item.stock

        this.crud.formStock.unit_measurement = this.itemSelected.unit_measurement_purchase_default
        this.crud.formStock.unit_measurement_id = this.itemSelected.unit_measurement_purchase_default.id

        this.crud.formStock.detail = []
        this.tableStock.items = []

        this.itemSelectedVariant = item

        var openModal = () => {
          this.modal.formStockVariant.active = true

          if(this.isProcessDeposit) {
            this.modal.formStockVariant.title = "VARIEDAD - Stock"
          } else {
            this.modal.formStockVariant.title = "VARIEDAD - Mantenimiento de Stock"
          }
        }

        if(!this.isProcessDeposit) {
          openModal()
          return
        }

        // Mismo criterio que setStockProducts: el detalle por depósito se
        // pide puntual al abrir el modal, ya no viene en el listado.
        let loader = this.$loading.show();
        var typeVariant = this.getTypeVariantAlt()
        var result = serviceAPI.mostrarVariedad(item.id, typeVariant)

        result.then((response) => {
          var data = response.data
          if(data.depositLocationDetail) {
            data.depositLocationDetail.forEach(element => {
              this.crud.formStock.detail.push({
                'deposit': element.location ? element.location.full_reference : '',
                'location': element.location || null,
                'quantity': element.quantity,
                'unit_measurement': this.crud.formStock.unit_measurement,
              })
            });
          }
          this.tableStock.items = this.crud.formStock.detail

          loader.hide()
          openModal()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      saveFormStockVariant(){
        if(!this.productControlsStock(this.itemSelected)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        this.confirmDialog('Desea continuar con la actualización de stock?', {
          title: 'Actualizar Stock',
          icon: 'box',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {        
            let loader = this.$loading.show();

            if (!this.crud.formStockVariant.id) { 
              this.$awn.alert(Error.showError("No se cargo el item"));
              return false
            }

            var typeVariant = this.getTypeVariantAlt()            
            var result = serviceAPI.editarProductStockVariedad(this.crud.formStockVariant, typeVariant)

            result.then((response) => {                         
              loader.hide()
              this.filterProducts(true, false, false, false, true)
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })       
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })                   
      },  
      saveFormStockMinimumVariant() {
        if(!this.productControlsStock(this.itemSelected)) {
          this.$awn.alert('El producto seleccionado no controla stock y no permite mantenimiento de stock')
          return
        }

        this.confirmDialog('Actualizar el stock mínimo?', {
          title: 'Actualizar Stock Mínimo',
          icon: 'box',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {

            let loader = this.$loading.show();

            if (!this.crud.formStockMinimum.id) { 
              this.$awn.alert(Error.showError("No se cargo el item"));
              return false
            }
            
            var typeVariant = this.getTypeVariantAlt()            
            var result = serviceAPI.editarProductStockMinimumVariedad(this.crud.formStockMinimum, typeVariant)
            
            result.then((response) => {                         
              loader.hide()
              this.filterProducts(true, false, false, false, true)          
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })       
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })                   
      },      
      loadZone() {        
        this.arr.zone = []
        var result = serviceAPI.obtenerDepositoZona()

        result.then((response) => {
          var data = response.data
          this.arr.depositeZone = data           
        })
      },    

      openProductsWeb(item) {
        if(item){
          this.$router.push({ name: 'ProductsStaffCrudProductsWeb', params: {codeProduct: item.code }})
        } else {
          this.$router.push({ name: 'ProductsStaffCrudProductsWeb'})
        }
      },

      // EXPORT
      openExport() {
        this.modal.formExport.active = true
        this.modal.formExport.title = "Exportación de Productos"
      },
      getFiltersForExport(type) {
        let filters = JSON.parse(JSON.stringify(this.filters))

        filters.listFullToCSV = true
        filters.price_list_id = this.modal.formExport.price_list.code
        filters.last_update_days = 0
        filters.hide_price_zero = false

        switch (type) {
          case 'filter-full-list-price-hide-price-zero':
            filters.hide_price_zero = true
            break

          case 'filter-list-price-last-update':
            filters.last_update_days = 7
            break
        }

        return filters
      },
      downloadSource(type) {
        var result = null
        var data = null
        const exportFilters = this.getFiltersForExport(type)

        switch (type) {
          case 'filter-full-list-price':
            this.modal.formExport.overlay = true
            result = serviceAPI.filtrarProducto(exportFilters)        
            result.then((response) => {          
              data = response.data
              Funciones.exportToCSV(data, this.modal.formExport.price_list.label + '-product-price-list-download')                    
              this.modal.formExport.overlay = false
            })
            .catch(error => {
              this.modal.formExport.overlay = false
            })
            break;

          case 'filter-full-list-price-hide-price-zero':
            this.modal.formExport.overlay = true
            result = serviceAPI.filtrarProducto(exportFilters)        
            result.then((response) => {          
              data = response.data
              Funciones.exportToCSV(data, this.modal.formExport.price_list.label + '-product-price-list-download')                    
              this.modal.formExport.overlay = false
            })
            .catch(error => {
              this.modal.formExport.overlay = false
            })
            break;

          case 'filter-list-price-last-update':
            this.modal.formExport.overlay = true
            result = serviceAPI.filtrarProducto(exportFilters)        
            result.then((response) => {          
              data = response.data
              Funciones.exportToCSV(data, this.modal.formExport.price_list.label + '-product-price-list-download')                    
              this.modal.formExport.overlay = false
            })
            .catch(error => {
              this.modal.formExport.overlay = false
            })
            break;            
        }        
      },      

      printPDF(type) {        
        this.crud.print.key = Math.random()
        this.crud.print.filters = this.getFiltersForExport(type)
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_product', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_product')) {
          this.filters = Object.assign(defaultFilters(), JSON.parse(Storage.getValue('filter_crud_product')))
        }         
      },
      syncFilterSupplier() {
        if(!this.filters.supplier || !this.filters.supplier.code) {
          return
        }

        const supplier = this.arr.select.suppliers.find((element) => parseInt(element.code) === parseInt(this.filters.supplier.code))
        if(supplier) {
          this.filters.supplier = supplier
        } else {
          this.filters.supplier = null
          this.saveFilterStorage()
          this.filterProducts()
        }
      },            
    }    
  }
</script>
<style>
  .crud-products-title {
    font-size: 15px;    
    font-weight: 600;
  }
  .crud-products-code {
    color: gray;
  }
  .crud-products-title-table {
    font-size: 12px;    
  }
  .crud-products-code-table {
    color: gray;
    font-size: 10px;    
    font-weight: 600;
  }
  .crud-product-image {
    height: 40px;
  }

  .products-tablesub-observations {
    color: darkred;
  }
  .crud-product-table-show {
    font-size: 15px;
  }  
  .crud-products-button-save-price {
    margin-top: 30px;
  }
  .crud-product-list-prices-public {
    font-size: 10px;
    font-weight: 600;
    color: gray;
  }
  .crud-products-table-prices {
    min-height: 100px;
  }
  .crud-products-table-button-variant {
    padding: 2px;
    padding-left: 3px;
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .crud-product-interested {
    font-size: 13px;
  }
  .crud-product-featured-custom {
    color: red; 
    font-size: 15px;
    float: right;     
  }  
  .popover-target-observations p {
    margin-bottom: 0px;
  }
  .popover-name-products .popover-body hr{
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }    
  .crud-products-stock-open:hover {
    font-weight: bold;
    font-style: italic;
    cursor: pointer;
  }
  .crud-products-stock-disabled {
    color: var(--app-color-text-muted);
    display: inline-flex;
    font-size: 17px;
    opacity: .75;
  }
  .crud-products-price-open:hover {
    font-style: italic;
    cursor: pointer;
  }
  .btn.crud-products-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-products-action-toggle-labeled:hover,
  .btn.crud-products-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-products-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before,
    .crud-products-table-prices.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
